var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 1404,
    viewBox: "0 0 1386 1404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.71325 11.2693C10.0136 11.2693 12.689 8.74655 12.689 5.63465C12.689 2.52275 10.0136 0 6.71325 0C3.41295 0 0.737549 2.52275 0.737549 5.63465C0.737549 8.74655 3.41295 11.2693 6.71325 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.3346 11.2693C78.6349 11.2693 81.3103 8.74655 81.3103 5.63465C81.3103 2.52275 78.6349 0 75.3346 0C72.0343 0 69.3589 2.52275 69.3589 5.63465C69.3589 8.74655 72.0343 11.2693 75.3346 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M143.956 11.2693C147.256 11.2693 149.931 8.74655 149.931 5.63465C149.931 2.52275 147.256 0 143.956 0C140.655 0 137.98 2.52275 137.98 5.63465C137.98 8.74655 140.655 11.2693 143.956 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M212.577 11.2693C215.877 11.2693 218.553 8.74655 218.553 5.63465C218.553 2.52275 215.877 0 212.577 0C209.277 0 206.601 2.52275 206.601 5.63465C206.601 8.74655 209.277 11.2693 212.577 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M281.198 11.2693C284.498 11.2693 287.174 8.74655 287.174 5.63465C287.174 2.52275 284.498 0 281.198 0C277.898 0 275.222 2.52275 275.222 5.63465C275.222 8.74655 277.898 11.2693 281.198 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M349.819 11.2693C353.12 11.2693 355.795 8.74655 355.795 5.63465C355.795 2.52275 353.12 0 349.819 0C346.519 0 343.844 2.52275 343.844 5.63465C343.844 8.74655 346.519 11.2693 349.819 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M418.49 11.2693C421.791 11.2693 424.466 8.74655 424.466 5.63465C424.466 2.52275 421.791 0 418.49 0C415.19 0 412.515 2.52275 412.515 5.63465C412.515 8.74655 415.19 11.2693 418.49 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M487.111 11.2693C490.412 11.2693 493.087 8.74655 493.087 5.63465C493.087 2.52275 490.412 0 487.111 0C483.811 0 481.136 2.52275 481.136 5.63465C481.136 8.74655 483.811 11.2693 487.111 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M561.709 5.63465C561.709 8.73368 559.02 11.2693 555.733 11.2693C552.446 11.2693 549.757 8.73368 549.757 5.63465C549.757 2.53562 552.446 0 555.733 0C559.02 0 561.709 2.53562 561.709 5.63465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M624.354 11.2693C627.654 11.2693 630.329 8.74655 630.329 5.63465C630.329 2.52275 627.654 0 624.354 0C621.053 0 618.378 2.52275 618.378 5.63465C618.378 8.74655 621.053 11.2693 624.354 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M692.975 11.2693C696.275 11.2693 698.951 8.74655 698.951 5.63465C698.951 2.52275 696.275 0 692.975 0C689.675 0 686.999 2.52275 686.999 5.63465C686.999 8.74655 689.675 11.2693 692.975 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M761.596 11.2693C764.896 11.2693 767.572 8.74655 767.572 5.63465C767.572 2.52275 764.896 0 761.596 0C758.296 0 755.62 2.52275 755.62 5.63465C755.62 8.74655 758.296 11.2693 761.596 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M830.267 11.2693C833.568 11.2693 836.243 8.74655 836.243 5.63465C836.243 2.52275 833.568 0 830.267 0C826.967 0 824.292 2.52275 824.292 5.63465C824.292 8.74655 826.967 11.2693 830.267 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M898.888 11.2693C902.189 11.2693 904.864 8.74655 904.864 5.63465C904.864 2.52275 902.189 0 898.888 0C895.588 0 892.913 2.52275 892.913 5.63465C892.913 8.74655 895.588 11.2693 898.888 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M967.51 11.2693C970.81 11.2693 973.485 8.74655 973.485 5.63465C973.485 2.52275 970.81 0 967.51 0C964.209 0 961.534 2.52275 961.534 5.63465C961.534 8.74655 964.209 11.2693 967.51 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1036.13 11.2693C1039.43 11.2693 1042.11 8.74655 1042.11 5.63465C1042.11 2.52275 1039.43 0 1036.13 0C1032.83 0 1030.16 2.52275 1030.16 5.63465C1030.16 8.74655 1032.83 11.2693 1036.13 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1104.75 11.2693C1108.05 11.2693 1110.73 8.74655 1110.73 5.63465C1110.73 2.52275 1108.05 0 1104.75 0C1101.45 0 1098.78 2.52275 1098.78 5.63465C1098.78 8.74655 1101.45 11.2693 1104.75 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1173.37 11.2693C1176.67 11.2693 1179.35 8.74655 1179.35 5.63465C1179.35 2.52275 1176.67 0 1173.37 0C1170.07 0 1167.4 2.52275 1167.4 5.63465C1167.4 8.74655 1170.07 11.2693 1173.37 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1247.97 5.63465C1247.97 8.73368 1245.28 11.2693 1241.99 11.2693C1238.71 11.2693 1236.02 8.73368 1236.02 5.63465C1236.02 2.53562 1238.71 0 1241.99 0C1245.33 0 1247.97 2.53562 1247.97 5.63465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M1310.67 11.2693C1313.97 11.2693 1316.64 8.74655 1316.64 5.63465C1316.64 2.52275 1313.97 0 1310.67 0C1307.37 0 1304.69 2.52275 1304.69 5.63465C1304.69 8.74655 1307.37 11.2693 1310.67 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M1379.29 11.2693C1382.59 11.2693 1385.26 8.74655 1385.26 5.63465C1385.26 2.52275 1382.59 0 1379.29 0C1375.99 0 1373.31 2.52275 1373.31 5.63465C1373.31 8.74655 1375.99 11.2693 1379.29 11.2693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.71325 74.5643C10.0136 74.5643 12.689 72.0417 12.689 68.9298C12.689 65.8179 10.0136 63.2952 6.71325 63.2952C3.41295 63.2952 0.737549 65.8179 0.737549 68.9298C0.737549 72.0417 3.41295 74.5643 6.71325 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M75.3346 74.5643C78.6349 74.5643 81.3103 72.0417 81.3103 68.9298C81.3103 65.8179 78.6349 63.2952 75.3346 63.2952C72.0343 63.2952 69.3589 65.8179 69.3589 68.9298C69.3589 72.0417 72.0343 74.5643 75.3346 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M143.956 74.5643C147.256 74.5643 149.931 72.0417 149.931 68.9298C149.931 65.8179 147.256 63.2952 143.956 63.2952C140.655 63.2952 137.98 65.8179 137.98 68.9298C137.98 72.0417 140.655 74.5643 143.956 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M212.577 74.5643C215.877 74.5643 218.553 72.0417 218.553 68.9298C218.553 65.8179 215.877 63.2952 212.577 63.2952C209.277 63.2952 206.601 65.8179 206.601 68.9298C206.601 72.0417 209.277 74.5643 212.577 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M281.198 74.5643C284.498 74.5643 287.174 72.0417 287.174 68.9298C287.174 65.8179 284.498 63.2952 281.198 63.2952C277.898 63.2952 275.222 65.8179 275.222 68.9298C275.222 72.0417 277.898 74.5643 281.198 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M349.819 74.5643C353.12 74.5643 355.795 72.0417 355.795 68.9298C355.795 65.8179 353.12 63.2952 349.819 63.2952C346.519 63.2952 343.844 65.8179 343.844 68.9298C343.844 72.0417 346.519 74.5643 349.819 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M418.49 74.5643C421.791 74.5643 424.466 72.0417 424.466 68.9298C424.466 65.8179 421.791 63.2952 418.49 63.2952C415.19 63.2952 412.515 65.8179 412.515 68.9298C412.515 72.0417 415.19 74.5643 418.49 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M487.111 74.5643C490.412 74.5643 493.087 72.0417 493.087 68.9298C493.087 65.8179 490.412 63.2952 487.111 63.2952C483.811 63.2952 481.136 65.8179 481.136 68.9298C481.136 72.0417 483.811 74.5643 487.111 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M561.709 68.9298C561.709 72.0288 559.02 74.5643 555.733 74.5643C552.446 74.5643 549.757 72.0288 549.757 68.9298C549.757 65.8308 552.446 63.2952 555.733 63.2952C559.02 63.3421 561.709 65.8308 561.709 68.9298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M624.354 74.5643C627.654 74.5643 630.329 72.0417 630.329 68.9298C630.329 65.8179 627.654 63.2952 624.354 63.2952C621.053 63.2952 618.378 65.8179 618.378 68.9298C618.378 72.0417 621.053 74.5643 624.354 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M692.975 74.5643C696.275 74.5643 698.951 72.0417 698.951 68.9298C698.951 65.8179 696.275 63.2952 692.975 63.2952C689.675 63.2952 686.999 65.8179 686.999 68.9298C686.999 72.0417 689.675 74.5643 692.975 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M761.596 74.5643C764.896 74.5643 767.572 72.0417 767.572 68.9298C767.572 65.8179 764.896 63.2952 761.596 63.2952C758.296 63.2952 755.62 65.8179 755.62 68.9298C755.62 72.0417 758.296 74.5643 761.596 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M830.267 74.5643C833.568 74.5643 836.243 72.0417 836.243 68.9298C836.243 65.8179 833.568 63.2952 830.267 63.2952C826.967 63.2952 824.292 65.8179 824.292 68.9298C824.292 72.0417 826.967 74.5643 830.267 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M898.888 74.5643C902.189 74.5643 904.864 72.0417 904.864 68.9298C904.864 65.8179 902.189 63.2952 898.888 63.2952C895.588 63.2952 892.913 65.8179 892.913 68.9298C892.913 72.0417 895.588 74.5643 898.888 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M967.51 74.5643C970.81 74.5643 973.485 72.0417 973.485 68.9298C973.485 65.8179 970.81 63.2952 967.51 63.2952C964.209 63.2952 961.534 65.8179 961.534 68.9298C961.534 72.0417 964.209 74.5643 967.51 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M1036.13 74.5643C1039.43 74.5643 1042.11 72.0417 1042.11 68.9298C1042.11 65.8179 1039.43 63.2952 1036.13 63.2952C1032.83 63.2952 1030.16 65.8179 1030.16 68.9298C1030.16 72.0417 1032.83 74.5643 1036.13 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M1104.75 74.5643C1108.05 74.5643 1110.73 72.0417 1110.73 68.9298C1110.73 65.8179 1108.05 63.2952 1104.75 63.2952C1101.45 63.2952 1098.78 65.8179 1098.78 68.9298C1098.78 72.0417 1101.45 74.5643 1104.75 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M1173.37 74.5643C1176.67 74.5643 1179.35 72.0417 1179.35 68.9298C1179.35 65.8179 1176.67 63.2952 1173.37 63.2952C1170.07 63.2952 1167.4 65.8179 1167.4 68.9298C1167.4 72.0417 1170.07 74.5643 1173.37 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M1247.97 68.9298C1247.97 72.0288 1245.28 74.5643 1241.99 74.5643C1238.71 74.5643 1236.02 72.0288 1236.02 68.9298C1236.02 65.8308 1238.71 63.2952 1241.99 63.2952C1245.33 63.3421 1247.97 65.8308 1247.97 68.9298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M1310.67 74.5643C1313.97 74.5643 1316.64 72.0417 1316.64 68.9298C1316.64 65.8179 1313.97 63.2952 1310.67 63.2952C1307.37 63.2952 1304.69 65.8179 1304.69 68.9298C1304.69 72.0417 1307.37 74.5643 1310.67 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M1379.29 74.5643C1382.59 74.5643 1385.26 72.0417 1385.26 68.9298C1385.26 65.8179 1382.59 63.2952 1379.29 63.2952C1375.99 63.2952 1373.31 65.8179 1373.31 68.9298C1373.31 72.0417 1375.99 74.5643 1379.29 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M6.71325 137.907C10.0136 137.907 12.689 135.384 12.689 132.272C12.689 129.16 10.0136 126.637 6.71325 126.637C3.41295 126.637 0.737549 129.16 0.737549 132.272C0.737549 135.384 3.41295 137.907 6.71325 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M75.3346 137.907C78.6349 137.907 81.3103 135.384 81.3103 132.272C81.3103 129.16 78.6349 126.637 75.3346 126.637C72.0343 126.637 69.3589 129.16 69.3589 132.272C69.3589 135.384 72.0343 137.907 75.3346 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M143.956 137.907C147.256 137.907 149.931 135.384 149.931 132.272C149.931 129.16 147.256 126.637 143.956 126.637C140.655 126.637 137.98 129.16 137.98 132.272C137.98 135.384 140.655 137.907 143.956 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M212.577 137.907C215.877 137.907 218.553 135.384 218.553 132.272C218.553 129.16 215.877 126.637 212.577 126.637C209.277 126.637 206.601 129.16 206.601 132.272C206.601 135.384 209.277 137.907 212.577 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M281.198 137.907C284.498 137.907 287.174 135.384 287.174 132.272C287.174 129.16 284.498 126.637 281.198 126.637C277.898 126.637 275.222 129.16 275.222 132.272C275.222 135.384 277.898 137.907 281.198 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M349.819 137.907C353.12 137.907 355.795 135.384 355.795 132.272C355.795 129.16 353.12 126.637 349.819 126.637C346.519 126.637 343.844 129.16 343.844 132.272C343.844 135.384 346.519 137.907 349.819 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M418.49 137.907C421.791 137.907 424.466 135.384 424.466 132.272C424.466 129.16 421.791 126.637 418.49 126.637C415.19 126.637 412.515 129.16 412.515 132.272C412.515 135.384 415.19 137.907 418.49 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M487.111 137.907C490.412 137.907 493.087 135.384 493.087 132.272C493.087 129.16 490.412 126.637 487.111 126.637C483.811 126.637 481.136 129.16 481.136 132.272C481.136 135.384 483.811 137.907 487.111 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M561.709 132.272C561.709 135.371 559.02 137.907 555.733 137.907C552.446 137.907 549.757 135.371 549.757 132.272C549.757 129.173 552.446 126.637 555.733 126.637C559.02 126.637 561.709 129.126 561.709 132.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M624.354 137.907C627.654 137.907 630.329 135.384 630.329 132.272C630.329 129.16 627.654 126.637 624.354 126.637C621.053 126.637 618.378 129.16 618.378 132.272C618.378 135.384 621.053 137.907 624.354 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M692.975 137.907C696.275 137.907 698.951 135.384 698.951 132.272C698.951 129.16 696.275 126.637 692.975 126.637C689.675 126.637 686.999 129.16 686.999 132.272C686.999 135.384 689.675 137.907 692.975 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M761.596 137.907C764.896 137.907 767.572 135.384 767.572 132.272C767.572 129.16 764.896 126.637 761.596 126.637C758.296 126.637 755.62 129.16 755.62 132.272C755.62 135.384 758.296 137.907 761.596 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M830.267 137.907C833.568 137.907 836.243 135.384 836.243 132.272C836.243 129.16 833.568 126.637 830.267 126.637C826.967 126.637 824.292 129.16 824.292 132.272C824.292 135.384 826.967 137.907 830.267 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M898.888 137.907C902.189 137.907 904.864 135.384 904.864 132.272C904.864 129.16 902.189 126.637 898.888 126.637C895.588 126.637 892.913 129.16 892.913 132.272C892.913 135.384 895.588 137.907 898.888 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M967.51 137.907C970.81 137.907 973.485 135.384 973.485 132.272C973.485 129.16 970.81 126.637 967.51 126.637C964.209 126.637 961.534 129.16 961.534 132.272C961.534 135.384 964.209 137.907 967.51 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M1036.13 137.907C1039.43 137.907 1042.11 135.384 1042.11 132.272C1042.11 129.16 1039.43 126.637 1036.13 126.637C1032.83 126.637 1030.16 129.16 1030.16 132.272C1030.16 135.384 1032.83 137.907 1036.13 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M1104.75 137.907C1108.05 137.907 1110.73 135.384 1110.73 132.272C1110.73 129.16 1108.05 126.637 1104.75 126.637C1101.45 126.637 1098.78 129.16 1098.78 132.272C1098.78 135.384 1101.45 137.907 1104.75 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M1173.37 137.907C1176.67 137.907 1179.35 135.384 1179.35 132.272C1179.35 129.16 1176.67 126.637 1173.37 126.637C1170.07 126.637 1167.4 129.16 1167.4 132.272C1167.4 135.384 1170.07 137.907 1173.37 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M1247.97 132.272C1247.97 135.371 1245.28 137.907 1241.99 137.907C1238.71 137.907 1236.02 135.371 1236.02 132.272C1236.02 129.173 1238.71 126.637 1241.99 126.637C1245.33 126.637 1247.97 129.126 1247.97 132.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M1310.67 137.907C1313.97 137.907 1316.64 135.384 1316.64 132.272C1316.64 129.16 1313.97 126.637 1310.67 126.637C1307.37 126.637 1304.69 129.16 1304.69 132.272C1304.69 135.384 1307.37 137.907 1310.67 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M1379.29 137.907C1382.59 137.907 1385.26 135.384 1385.26 132.272C1385.26 129.16 1382.59 126.637 1379.29 126.637C1375.99 126.637 1373.31 129.16 1373.31 132.272C1373.31 135.384 1375.99 137.907 1379.29 137.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M6.71325 201.202C10.0136 201.202 12.689 198.679 12.689 195.567C12.689 192.455 10.0136 189.932 6.71325 189.932C3.41295 189.932 0.737549 192.455 0.737549 195.567C0.737549 198.679 3.41295 201.202 6.71325 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M75.3346 201.202C78.6349 201.202 81.3103 198.679 81.3103 195.567C81.3103 192.455 78.6349 189.932 75.3346 189.932C72.0343 189.932 69.3589 192.455 69.3589 195.567C69.3589 198.679 72.0343 201.202 75.3346 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M143.956 201.202C147.256 201.202 149.931 198.679 149.931 195.567C149.931 192.455 147.256 189.932 143.956 189.932C140.655 189.932 137.98 192.455 137.98 195.567C137.98 198.679 140.655 201.202 143.956 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M212.577 201.202C215.877 201.202 218.553 198.679 218.553 195.567C218.553 192.455 215.877 189.932 212.577 189.932C209.277 189.932 206.601 192.455 206.601 195.567C206.601 198.679 209.277 201.202 212.577 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M281.198 201.202C284.498 201.202 287.174 198.679 287.174 195.567C287.174 192.455 284.498 189.932 281.198 189.932C277.898 189.932 275.222 192.455 275.222 195.567C275.222 198.679 277.898 201.202 281.198 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M349.819 201.202C353.12 201.202 355.795 198.679 355.795 195.567C355.795 192.455 353.12 189.932 349.819 189.932C346.519 189.932 343.844 192.455 343.844 195.567C343.844 198.679 346.519 201.202 349.819 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M418.49 201.202C421.791 201.202 424.466 198.679 424.466 195.567C424.466 192.455 421.791 189.932 418.49 189.932C415.19 189.932 412.515 192.455 412.515 195.567C412.515 198.679 415.19 201.202 418.49 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M487.111 201.202C490.412 201.202 493.087 198.679 493.087 195.567C493.087 192.455 490.412 189.932 487.111 189.932C483.811 189.932 481.136 192.455 481.136 195.567C481.136 198.679 483.811 201.202 487.111 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M561.709 195.567C561.709 198.666 559.02 201.202 555.733 201.202C552.446 201.202 549.757 198.666 549.757 195.567C549.757 192.468 552.446 189.932 555.733 189.932C559.02 189.932 561.709 192.468 561.709 195.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M624.354 201.202C627.654 201.202 630.329 198.679 630.329 195.567C630.329 192.455 627.654 189.932 624.354 189.932C621.053 189.932 618.378 192.455 618.378 195.567C618.378 198.679 621.053 201.202 624.354 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M692.975 201.202C696.275 201.202 698.951 198.679 698.951 195.567C698.951 192.455 696.275 189.932 692.975 189.932C689.675 189.932 686.999 192.455 686.999 195.567C686.999 198.679 689.675 201.202 692.975 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M761.596 201.202C764.896 201.202 767.572 198.679 767.572 195.567C767.572 192.455 764.896 189.932 761.596 189.932C758.296 189.932 755.62 192.455 755.62 195.567C755.62 198.679 758.296 201.202 761.596 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M830.267 201.202C833.568 201.202 836.243 198.679 836.243 195.567C836.243 192.455 833.568 189.932 830.267 189.932C826.967 189.932 824.292 192.455 824.292 195.567C824.292 198.679 826.967 201.202 830.267 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M898.888 201.202C902.189 201.202 904.864 198.679 904.864 195.567C904.864 192.455 902.189 189.932 898.888 189.932C895.588 189.932 892.913 192.455 892.913 195.567C892.913 198.679 895.588 201.202 898.888 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M967.51 201.202C970.81 201.202 973.485 198.679 973.485 195.567C973.485 192.455 970.81 189.932 967.51 189.932C964.209 189.932 961.534 192.455 961.534 195.567C961.534 198.679 964.209 201.202 967.51 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M1036.13 201.202C1039.43 201.202 1042.11 198.679 1042.11 195.567C1042.11 192.455 1039.43 189.932 1036.13 189.932C1032.83 189.932 1030.16 192.455 1030.16 195.567C1030.16 198.679 1032.83 201.202 1036.13 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M1104.75 201.202C1108.05 201.202 1110.73 198.679 1110.73 195.567C1110.73 192.455 1108.05 189.932 1104.75 189.932C1101.45 189.932 1098.78 192.455 1098.78 195.567C1098.78 198.679 1101.45 201.202 1104.75 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M1173.37 201.202C1176.67 201.202 1179.35 198.679 1179.35 195.567C1179.35 192.455 1176.67 189.932 1173.37 189.932C1170.07 189.932 1167.4 192.455 1167.4 195.567C1167.4 198.679 1170.07 201.202 1173.37 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M1247.97 195.567C1247.97 198.666 1245.28 201.202 1241.99 201.202C1238.71 201.202 1236.02 198.666 1236.02 195.567C1236.02 192.468 1238.71 189.932 1241.99 189.932C1245.33 189.932 1247.97 192.468 1247.97 195.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M1310.67 201.202C1313.97 201.202 1316.64 198.679 1316.64 195.567C1316.64 192.455 1313.97 189.932 1310.67 189.932C1307.37 189.932 1304.69 192.455 1304.69 195.567C1304.69 198.679 1307.37 201.202 1310.67 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M1379.29 201.202C1382.59 201.202 1385.26 198.679 1385.26 195.567C1385.26 192.455 1382.59 189.932 1379.29 189.932C1375.99 189.932 1373.31 192.455 1373.31 195.567C1373.31 198.679 1375.99 201.202 1379.29 201.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M6.71325 264.497C10.0136 264.497 12.689 261.975 12.689 258.863C12.689 255.751 10.0136 253.228 6.71325 253.228C3.41295 253.228 0.737549 255.751 0.737549 258.863C0.737549 261.975 3.41295 264.497 6.71325 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M75.3346 264.497C78.6349 264.497 81.3103 261.975 81.3103 258.863C81.3103 255.751 78.6349 253.228 75.3346 253.228C72.0343 253.228 69.3589 255.751 69.3589 258.863C69.3589 261.975 72.0343 264.497 75.3346 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M143.956 264.497C147.256 264.497 149.931 261.975 149.931 258.863C149.931 255.751 147.256 253.228 143.956 253.228C140.655 253.228 137.98 255.751 137.98 258.863C137.98 261.975 140.655 264.497 143.956 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M212.577 264.497C215.877 264.497 218.553 261.975 218.553 258.863C218.553 255.751 215.877 253.228 212.577 253.228C209.277 253.228 206.601 255.751 206.601 258.863C206.601 261.975 209.277 264.497 212.577 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M281.198 264.497C284.498 264.497 287.174 261.975 287.174 258.863C287.174 255.751 284.498 253.228 281.198 253.228C277.898 253.228 275.222 255.751 275.222 258.863C275.222 261.975 277.898 264.497 281.198 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M349.819 264.497C353.12 264.497 355.795 261.975 355.795 258.863C355.795 255.751 353.12 253.228 349.819 253.228C346.519 253.228 343.844 255.751 343.844 258.863C343.844 261.975 346.519 264.497 349.819 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M418.49 264.497C421.791 264.497 424.466 261.975 424.466 258.863C424.466 255.751 421.791 253.228 418.49 253.228C415.19 253.228 412.515 255.751 412.515 258.863C412.515 261.975 415.19 264.497 418.49 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M487.111 264.497C490.412 264.497 493.087 261.975 493.087 258.863C493.087 255.751 490.412 253.228 487.111 253.228C483.811 253.228 481.136 255.751 481.136 258.863C481.136 261.975 483.811 264.497 487.111 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M561.709 258.863C561.709 261.962 559.02 264.497 555.733 264.497C552.446 264.497 549.757 261.962 549.757 258.863C549.757 255.764 552.446 253.228 555.733 253.228C559.02 253.228 561.709 255.764 561.709 258.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M624.354 264.497C627.654 264.497 630.329 261.975 630.329 258.863C630.329 255.751 627.654 253.228 624.354 253.228C621.053 253.228 618.378 255.751 618.378 258.863C618.378 261.975 621.053 264.497 624.354 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M692.975 264.497C696.275 264.497 698.951 261.975 698.951 258.863C698.951 255.751 696.275 253.228 692.975 253.228C689.675 253.228 686.999 255.751 686.999 258.863C686.999 261.975 689.675 264.497 692.975 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M761.596 264.497C764.896 264.497 767.572 261.975 767.572 258.863C767.572 255.751 764.896 253.228 761.596 253.228C758.296 253.228 755.62 255.751 755.62 258.863C755.62 261.975 758.296 264.497 761.596 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M830.267 264.497C833.568 264.497 836.243 261.975 836.243 258.863C836.243 255.751 833.568 253.228 830.267 253.228C826.967 253.228 824.292 255.751 824.292 258.863C824.292 261.975 826.967 264.497 830.267 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M898.888 264.497C902.189 264.497 904.864 261.975 904.864 258.863C904.864 255.751 902.189 253.228 898.888 253.228C895.588 253.228 892.913 255.751 892.913 258.863C892.913 261.975 895.588 264.497 898.888 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M967.51 264.497C970.81 264.497 973.485 261.975 973.485 258.863C973.485 255.751 970.81 253.228 967.51 253.228C964.209 253.228 961.534 255.751 961.534 258.863C961.534 261.975 964.209 264.497 967.51 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M1036.13 264.497C1039.43 264.497 1042.11 261.975 1042.11 258.863C1042.11 255.751 1039.43 253.228 1036.13 253.228C1032.83 253.228 1030.16 255.751 1030.16 258.863C1030.16 261.975 1032.83 264.497 1036.13 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M1104.75 264.497C1108.05 264.497 1110.73 261.975 1110.73 258.863C1110.73 255.751 1108.05 253.228 1104.75 253.228C1101.45 253.228 1098.78 255.751 1098.78 258.863C1098.78 261.975 1101.45 264.497 1104.75 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M1173.37 264.497C1176.67 264.497 1179.35 261.975 1179.35 258.863C1179.35 255.751 1176.67 253.228 1173.37 253.228C1170.07 253.228 1167.4 255.751 1167.4 258.863C1167.4 261.975 1170.07 264.497 1173.37 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M1247.97 258.863C1247.97 261.962 1245.28 264.497 1241.99 264.497C1238.71 264.497 1236.02 261.962 1236.02 258.863C1236.02 255.764 1238.71 253.228 1241.99 253.228C1245.33 253.228 1247.97 255.764 1247.97 258.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M1310.67 264.497C1313.97 264.497 1316.64 261.975 1316.64 258.863C1316.64 255.751 1313.97 253.228 1310.67 253.228C1307.37 253.228 1304.69 255.751 1304.69 258.863C1304.69 261.975 1307.37 264.497 1310.67 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M1379.29 264.497C1382.59 264.497 1385.26 261.975 1385.26 258.863C1385.26 255.751 1382.59 253.228 1379.29 253.228C1375.99 253.228 1373.31 255.751 1373.31 258.863C1373.31 261.975 1375.99 264.497 1379.29 264.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M6.71325 327.793C10.0136 327.793 12.689 325.27 12.689 322.159C12.689 319.047 10.0136 316.524 6.71325 316.524C3.41295 316.524 0.737549 319.047 0.737549 322.159C0.737549 325.27 3.41295 327.793 6.71325 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M75.3346 327.793C78.6349 327.793 81.3103 325.27 81.3103 322.159C81.3103 319.047 78.6349 316.524 75.3346 316.524C72.0343 316.524 69.3589 319.047 69.3589 322.159C69.3589 325.27 72.0343 327.793 75.3346 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M143.956 327.793C147.256 327.793 149.931 325.27 149.931 322.159C149.931 319.047 147.256 316.524 143.956 316.524C140.655 316.524 137.98 319.047 137.98 322.159C137.98 325.27 140.655 327.793 143.956 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M212.577 327.793C215.877 327.793 218.553 325.27 218.553 322.159C218.553 319.047 215.877 316.524 212.577 316.524C209.277 316.524 206.601 319.047 206.601 322.159C206.601 325.27 209.277 327.793 212.577 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M281.198 327.793C284.498 327.793 287.174 325.27 287.174 322.159C287.174 319.047 284.498 316.524 281.198 316.524C277.898 316.524 275.222 319.047 275.222 322.159C275.222 325.27 277.898 327.793 281.198 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M349.819 327.793C353.12 327.793 355.795 325.27 355.795 322.159C355.795 319.047 353.12 316.524 349.819 316.524C346.519 316.524 343.844 319.047 343.844 322.159C343.844 325.27 346.519 327.793 349.819 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M418.49 327.793C421.791 327.793 424.466 325.27 424.466 322.159C424.466 319.047 421.791 316.524 418.49 316.524C415.19 316.524 412.515 319.047 412.515 322.159C412.515 325.27 415.19 327.793 418.49 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M487.111 327.793C490.412 327.793 493.087 325.27 493.087 322.159C493.087 319.047 490.412 316.524 487.111 316.524C483.811 316.524 481.136 319.047 481.136 322.159C481.136 325.27 483.811 327.793 487.111 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M561.709 322.159C561.709 325.258 559.02 327.793 555.733 327.793C552.446 327.793 549.757 325.258 549.757 322.159C549.757 319.06 552.446 316.524 555.733 316.524C559.02 316.524 561.709 319.06 561.709 322.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M624.354 327.793C627.654 327.793 630.329 325.27 630.329 322.159C630.329 319.047 627.654 316.524 624.354 316.524C621.053 316.524 618.378 319.047 618.378 322.159C618.378 325.27 621.053 327.793 624.354 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M692.975 327.793C696.275 327.793 698.951 325.27 698.951 322.159C698.951 319.047 696.275 316.524 692.975 316.524C689.675 316.524 686.999 319.047 686.999 322.159C686.999 325.27 689.675 327.793 692.975 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M761.596 327.793C764.896 327.793 767.572 325.27 767.572 322.159C767.572 319.047 764.896 316.524 761.596 316.524C758.296 316.524 755.62 319.047 755.62 322.159C755.62 325.27 758.296 327.793 761.596 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M830.267 327.793C833.568 327.793 836.243 325.27 836.243 322.159C836.243 319.047 833.568 316.524 830.267 316.524C826.967 316.524 824.292 319.047 824.292 322.159C824.292 325.27 826.967 327.793 830.267 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M898.888 327.793C902.189 327.793 904.864 325.27 904.864 322.159C904.864 319.047 902.189 316.524 898.888 316.524C895.588 316.524 892.913 319.047 892.913 322.159C892.913 325.27 895.588 327.793 898.888 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M967.51 327.793C970.81 327.793 973.485 325.27 973.485 322.159C973.485 319.047 970.81 316.524 967.51 316.524C964.209 316.524 961.534 319.047 961.534 322.159C961.534 325.27 964.209 327.793 967.51 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M1036.13 327.793C1039.43 327.793 1042.11 325.27 1042.11 322.159C1042.11 319.047 1039.43 316.524 1036.13 316.524C1032.83 316.524 1030.16 319.047 1030.16 322.159C1030.16 325.27 1032.83 327.793 1036.13 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M1104.75 327.793C1108.05 327.793 1110.73 325.27 1110.73 322.159C1110.73 319.047 1108.05 316.524 1104.75 316.524C1101.45 316.524 1098.78 319.047 1098.78 322.159C1098.78 325.27 1101.45 327.793 1104.75 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M1173.37 327.793C1176.67 327.793 1179.35 325.27 1179.35 322.159C1179.35 319.047 1176.67 316.524 1173.37 316.524C1170.07 316.524 1167.4 319.047 1167.4 322.159C1167.4 325.27 1170.07 327.793 1173.37 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M1247.97 322.159C1247.97 325.258 1245.28 327.793 1241.99 327.793C1238.71 327.793 1236.02 325.258 1236.02 322.159C1236.02 319.06 1238.71 316.524 1241.99 316.524C1245.33 316.524 1247.97 319.06 1247.97 322.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M1310.67 327.793C1313.97 327.793 1316.64 325.27 1316.64 322.159C1316.64 319.047 1313.97 316.524 1310.67 316.524C1307.37 316.524 1304.69 319.047 1304.69 322.159C1304.69 325.27 1307.37 327.793 1310.67 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M1379.29 327.793C1382.59 327.793 1385.26 325.27 1385.26 322.159C1385.26 319.047 1382.59 316.524 1379.29 316.524C1375.99 316.524 1373.31 319.047 1373.31 322.159C1373.31 325.27 1375.99 327.793 1379.29 327.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M6.71325 391.089C10.0136 391.089 12.689 388.566 12.689 385.454C12.689 382.342 10.0136 379.819 6.71325 379.819C3.41295 379.819 0.737549 382.342 0.737549 385.454C0.737549 388.566 3.41295 391.089 6.71325 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M75.3346 391.089C78.6349 391.089 81.3103 388.566 81.3103 385.454C81.3103 382.342 78.6349 379.819 75.3346 379.819C72.0343 379.819 69.3589 382.342 69.3589 385.454C69.3589 388.566 72.0343 391.089 75.3346 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M143.956 391.089C147.256 391.089 149.931 388.566 149.931 385.454C149.931 382.342 147.256 379.819 143.956 379.819C140.655 379.819 137.98 382.342 137.98 385.454C137.98 388.566 140.655 391.089 143.956 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M212.577 391.089C215.877 391.089 218.553 388.566 218.553 385.454C218.553 382.342 215.877 379.819 212.577 379.819C209.277 379.819 206.601 382.342 206.601 385.454C206.601 388.566 209.277 391.089 212.577 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M281.198 391.089C284.498 391.089 287.174 388.566 287.174 385.454C287.174 382.342 284.498 379.819 281.198 379.819C277.898 379.819 275.222 382.342 275.222 385.454C275.222 388.566 277.898 391.089 281.198 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M349.819 391.089C353.12 391.089 355.795 388.566 355.795 385.454C355.795 382.342 353.12 379.819 349.819 379.819C346.519 379.819 343.844 382.342 343.844 385.454C343.844 388.566 346.519 391.089 349.819 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M418.49 391.089C421.791 391.089 424.466 388.566 424.466 385.454C424.466 382.342 421.791 379.819 418.49 379.819C415.19 379.819 412.515 382.342 412.515 385.454C412.515 388.566 415.19 391.089 418.49 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M487.111 391.089C490.412 391.089 493.087 388.566 493.087 385.454C493.087 382.342 490.412 379.819 487.111 379.819C483.811 379.819 481.136 382.342 481.136 385.454C481.136 388.566 483.811 391.089 487.111 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M561.709 385.454C561.709 388.553 559.02 391.089 555.733 391.089C552.446 391.089 549.757 388.553 549.757 385.454C549.757 382.355 552.446 379.819 555.733 379.819C559.02 379.866 561.709 382.355 561.709 385.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M624.354 391.089C627.654 391.089 630.329 388.566 630.329 385.454C630.329 382.342 627.654 379.819 624.354 379.819C621.053 379.819 618.378 382.342 618.378 385.454C618.378 388.566 621.053 391.089 624.354 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M692.975 391.089C696.275 391.089 698.951 388.566 698.951 385.454C698.951 382.342 696.275 379.819 692.975 379.819C689.675 379.819 686.999 382.342 686.999 385.454C686.999 388.566 689.675 391.089 692.975 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M761.596 391.089C764.896 391.089 767.572 388.566 767.572 385.454C767.572 382.342 764.896 379.819 761.596 379.819C758.296 379.819 755.62 382.342 755.62 385.454C755.62 388.566 758.296 391.089 761.596 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M830.267 391.089C833.568 391.089 836.243 388.566 836.243 385.454C836.243 382.342 833.568 379.819 830.267 379.819C826.967 379.819 824.292 382.342 824.292 385.454C824.292 388.566 826.967 391.089 830.267 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M898.888 391.089C902.189 391.089 904.864 388.566 904.864 385.454C904.864 382.342 902.189 379.819 898.888 379.819C895.588 379.819 892.913 382.342 892.913 385.454C892.913 388.566 895.588 391.089 898.888 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M967.51 391.089C970.81 391.089 973.485 388.566 973.485 385.454C973.485 382.342 970.81 379.819 967.51 379.819C964.209 379.819 961.534 382.342 961.534 385.454C961.534 388.566 964.209 391.089 967.51 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M1036.13 391.089C1039.43 391.089 1042.11 388.566 1042.11 385.454C1042.11 382.342 1039.43 379.819 1036.13 379.819C1032.83 379.819 1030.16 382.342 1030.16 385.454C1030.16 388.566 1032.83 391.089 1036.13 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M1104.75 391.089C1108.05 391.089 1110.73 388.566 1110.73 385.454C1110.73 382.342 1108.05 379.819 1104.75 379.819C1101.45 379.819 1098.78 382.342 1098.78 385.454C1098.78 388.566 1101.45 391.089 1104.75 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M1173.37 391.089C1176.67 391.089 1179.35 388.566 1179.35 385.454C1179.35 382.342 1176.67 379.819 1173.37 379.819C1170.07 379.819 1167.4 382.342 1167.4 385.454C1167.4 388.566 1170.07 391.089 1173.37 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M1247.97 385.454C1247.97 388.553 1245.28 391.089 1241.99 391.089C1238.71 391.089 1236.02 388.553 1236.02 385.454C1236.02 382.355 1238.71 379.819 1241.99 379.819C1245.33 379.866 1247.97 382.355 1247.97 385.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M1310.67 391.089C1313.97 391.089 1316.64 388.566 1316.64 385.454C1316.64 382.342 1313.97 379.819 1310.67 379.819C1307.37 379.819 1304.69 382.342 1304.69 385.454C1304.69 388.566 1307.37 391.089 1310.67 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M1379.29 391.089C1382.59 391.089 1385.26 388.566 1385.26 385.454C1385.26 382.342 1382.59 379.819 1379.29 379.819C1375.99 379.819 1373.31 382.342 1373.31 385.454C1373.31 388.566 1375.99 391.089 1379.29 391.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M12.689 448.795C12.689 451.894 9.9999 454.43 6.71325 454.43C3.42661 454.43 0.737549 451.894 0.737549 448.795C0.737549 445.696 3.42661 443.161 6.71325 443.161C9.9999 443.161 12.689 445.649 12.689 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M81.3103 448.795C81.3103 451.894 78.6212 454.43 75.3346 454.43C72.0479 454.43 69.3589 451.894 69.3589 448.795C69.3589 445.696 72.0479 443.161 75.3346 443.161C78.6212 443.161 81.3103 445.649 81.3103 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M149.931 448.795C149.931 451.894 147.242 454.43 143.956 454.43C140.669 454.43 137.98 451.894 137.98 448.795C137.98 445.696 140.669 443.161 143.956 443.161C147.242 443.161 149.931 445.649 149.931 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M218.553 448.795C218.553 451.894 215.864 454.43 212.577 454.43C209.29 454.43 206.601 451.894 206.601 448.795C206.601 445.696 209.29 443.161 212.577 443.161C215.864 443.161 218.553 445.649 218.553 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M287.174 448.795C287.174 451.894 284.485 454.43 281.198 454.43C277.911 454.43 275.222 451.894 275.222 448.795C275.222 445.696 277.911 443.161 281.198 443.161C284.485 443.161 287.174 445.649 287.174 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M355.795 448.795C355.795 451.894 353.106 454.43 349.819 454.43C346.533 454.43 343.844 451.894 343.844 448.795C343.844 445.696 346.533 443.161 349.819 443.161C353.156 443.161 355.795 445.649 355.795 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M424.416 448.795C424.416 451.894 421.727 454.43 418.44 454.43C415.154 454.43 412.465 451.894 412.465 448.795C412.465 445.696 415.154 443.161 418.44 443.161C421.777 443.161 424.416 445.649 424.416 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M493.087 448.795C493.087 451.894 490.398 454.43 487.111 454.43C483.825 454.43 481.136 451.894 481.136 448.795C481.136 445.696 483.825 443.161 487.111 443.161C490.398 443.161 493.087 445.649 493.087 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M561.709 448.795C561.709 451.894 559.02 454.43 555.733 454.43C552.446 454.43 549.757 451.894 549.757 448.795C549.757 445.696 552.446 443.161 555.733 443.161C559.02 443.161 561.709 445.649 561.709 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M630.329 448.795C630.329 451.894 627.64 454.43 624.354 454.43C621.067 454.43 618.378 451.894 618.378 448.795C618.378 445.696 621.067 443.161 624.354 443.161C627.64 443.161 630.329 445.649 630.329 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M698.951 448.795C698.951 451.894 696.262 454.43 692.975 454.43C689.689 454.43 686.999 451.894 686.999 448.795C686.999 445.696 689.689 443.161 692.975 443.161C696.262 443.161 698.951 445.649 698.951 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M767.572 448.795C767.572 451.894 764.883 454.43 761.596 454.43C758.309 454.43 755.62 451.894 755.62 448.795C755.62 445.696 758.309 443.161 761.596 443.161C764.933 443.161 767.572 445.649 767.572 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M836.193 448.795C836.193 451.894 833.504 454.43 830.217 454.43C826.931 454.43 824.242 451.894 824.242 448.795C824.242 445.696 826.931 443.161 830.217 443.161C833.554 443.161 836.193 445.649 836.193 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M904.864 448.795C904.864 451.894 902.175 454.43 898.888 454.43C895.602 454.43 892.913 451.894 892.913 448.795C892.913 445.696 895.602 443.161 898.888 443.161C902.175 443.161 904.864 445.649 904.864 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M973.485 448.795C973.485 451.894 970.796 454.43 967.51 454.43C964.223 454.43 961.534 451.894 961.534 448.795C961.534 445.696 964.223 443.161 967.51 443.161C970.796 443.161 973.485 445.649 973.485 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M1042.11 448.795C1042.11 451.894 1039.42 454.43 1036.13 454.43C1032.84 454.43 1030.16 451.894 1030.16 448.795C1030.16 445.696 1032.84 443.161 1036.13 443.161C1039.42 443.161 1042.11 445.649 1042.11 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M1110.73 448.795C1110.73 451.894 1108.04 454.43 1104.75 454.43C1101.47 454.43 1098.78 451.894 1098.78 448.795C1098.78 445.696 1101.47 443.161 1104.75 443.161C1108.04 443.161 1110.73 445.649 1110.73 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M1179.35 448.795C1179.35 451.894 1176.66 454.43 1173.37 454.43C1170.09 454.43 1167.4 451.894 1167.4 448.795C1167.4 445.696 1170.09 443.161 1173.37 443.161C1176.71 443.161 1179.35 445.649 1179.35 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M1247.97 448.795C1247.97 451.894 1245.28 454.43 1241.99 454.43C1238.71 454.43 1236.02 451.894 1236.02 448.795C1236.02 445.696 1238.71 443.161 1241.99 443.161C1245.33 443.161 1247.97 445.649 1247.97 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M1316.64 448.795C1316.64 451.894 1313.95 454.43 1310.67 454.43C1307.38 454.43 1304.69 451.894 1304.69 448.795C1304.69 445.696 1307.38 443.161 1310.67 443.161C1313.95 443.161 1316.64 445.649 1316.64 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M1385.26 448.795C1385.26 451.894 1382.57 454.43 1379.29 454.43C1376 454.43 1373.31 451.894 1373.31 448.795C1373.31 445.696 1376 443.161 1379.29 443.161C1382.57 443.161 1385.26 445.649 1385.26 448.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M6.71325 517.725C10.0136 517.725 12.689 515.202 12.689 512.09C12.689 508.978 10.0136 506.456 6.71325 506.456C3.41295 506.456 0.737549 508.978 0.737549 512.09C0.737549 515.202 3.41295 517.725 6.71325 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M75.3346 517.725C78.6349 517.725 81.3103 515.202 81.3103 512.09C81.3103 508.978 78.6349 506.456 75.3346 506.456C72.0343 506.456 69.3589 508.978 69.3589 512.09C69.3589 515.202 72.0343 517.725 75.3346 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M143.956 517.725C147.256 517.725 149.931 515.202 149.931 512.09C149.931 508.978 147.256 506.456 143.956 506.456C140.655 506.456 137.98 508.978 137.98 512.09C137.98 515.202 140.655 517.725 143.956 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M212.577 517.725C215.877 517.725 218.553 515.202 218.553 512.09C218.553 508.978 215.877 506.456 212.577 506.456C209.277 506.456 206.601 508.978 206.601 512.09C206.601 515.202 209.277 517.725 212.577 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M281.198 517.725C284.498 517.725 287.174 515.202 287.174 512.09C287.174 508.978 284.498 506.456 281.198 506.456C277.898 506.456 275.222 508.978 275.222 512.09C275.222 515.202 277.898 517.725 281.198 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M349.819 517.725C353.12 517.725 355.795 515.202 355.795 512.09C355.795 508.978 353.12 506.456 349.819 506.456C346.519 506.456 343.844 508.978 343.844 512.09C343.844 515.202 346.519 517.725 349.819 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M418.49 517.725C421.791 517.725 424.466 515.202 424.466 512.09C424.466 508.978 421.791 506.456 418.49 506.456C415.19 506.456 412.515 508.978 412.515 512.09C412.515 515.202 415.19 517.725 418.49 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M487.111 517.725C490.412 517.725 493.087 515.202 493.087 512.09C493.087 508.978 490.412 506.456 487.111 506.456C483.811 506.456 481.136 508.978 481.136 512.09C481.136 515.202 483.811 517.725 487.111 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M561.709 512.09C561.709 515.189 559.02 517.725 555.733 517.725C552.446 517.725 549.757 515.189 549.757 512.09C549.757 508.991 552.446 506.456 555.733 506.456C559.02 506.456 561.709 508.991 561.709 512.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M624.354 517.725C627.654 517.725 630.329 515.202 630.329 512.09C630.329 508.978 627.654 506.456 624.354 506.456C621.053 506.456 618.378 508.978 618.378 512.09C618.378 515.202 621.053 517.725 624.354 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M692.975 517.725C696.275 517.725 698.951 515.202 698.951 512.09C698.951 508.978 696.275 506.456 692.975 506.456C689.675 506.456 686.999 508.978 686.999 512.09C686.999 515.202 689.675 517.725 692.975 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M761.596 517.725C764.896 517.725 767.572 515.202 767.572 512.09C767.572 508.978 764.896 506.456 761.596 506.456C758.296 506.456 755.62 508.978 755.62 512.09C755.62 515.202 758.296 517.725 761.596 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M830.267 517.725C833.568 517.725 836.243 515.202 836.243 512.09C836.243 508.978 833.568 506.456 830.267 506.456C826.967 506.456 824.292 508.978 824.292 512.09C824.292 515.202 826.967 517.725 830.267 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M898.888 517.725C902.189 517.725 904.864 515.202 904.864 512.09C904.864 508.978 902.189 506.456 898.888 506.456C895.588 506.456 892.913 508.978 892.913 512.09C892.913 515.202 895.588 517.725 898.888 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M967.51 517.725C970.81 517.725 973.485 515.202 973.485 512.09C973.485 508.978 970.81 506.456 967.51 506.456C964.209 506.456 961.534 508.978 961.534 512.09C961.534 515.202 964.209 517.725 967.51 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M1036.13 517.725C1039.43 517.725 1042.11 515.202 1042.11 512.09C1042.11 508.978 1039.43 506.456 1036.13 506.456C1032.83 506.456 1030.16 508.978 1030.16 512.09C1030.16 515.202 1032.83 517.725 1036.13 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M1104.75 517.725C1108.05 517.725 1110.73 515.202 1110.73 512.09C1110.73 508.978 1108.05 506.456 1104.75 506.456C1101.45 506.456 1098.78 508.978 1098.78 512.09C1098.78 515.202 1101.45 517.725 1104.75 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M1173.37 517.725C1176.67 517.725 1179.35 515.202 1179.35 512.09C1179.35 508.978 1176.67 506.456 1173.37 506.456C1170.07 506.456 1167.4 508.978 1167.4 512.09C1167.4 515.202 1170.07 517.725 1173.37 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M1247.97 512.09C1247.97 515.189 1245.28 517.725 1241.99 517.725C1238.71 517.725 1236.02 515.189 1236.02 512.09C1236.02 508.991 1238.71 506.456 1241.99 506.456C1245.33 506.456 1247.97 508.991 1247.97 512.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M1310.67 517.725C1313.97 517.725 1316.64 515.202 1316.64 512.09C1316.64 508.978 1313.97 506.456 1310.67 506.456C1307.37 506.456 1304.69 508.978 1304.69 512.09C1304.69 515.202 1307.37 517.725 1310.67 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M1379.29 517.725C1382.59 517.725 1385.26 515.202 1385.26 512.09C1385.26 508.978 1382.59 506.456 1379.29 506.456C1375.99 506.456 1373.31 508.978 1373.31 512.09C1373.31 515.202 1375.99 517.725 1379.29 517.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M6.71325 581.02C10.0136 581.02 12.689 578.498 12.689 575.386C12.689 572.274 10.0136 569.751 6.71325 569.751C3.41295 569.751 0.737549 572.274 0.737549 575.386C0.737549 578.498 3.41295 581.02 6.71325 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M75.3346 581.02C78.6349 581.02 81.3103 578.498 81.3103 575.386C81.3103 572.274 78.6349 569.751 75.3346 569.751C72.0343 569.751 69.3589 572.274 69.3589 575.386C69.3589 578.498 72.0343 581.02 75.3346 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M143.956 581.02C147.256 581.02 149.931 578.498 149.931 575.386C149.931 572.274 147.256 569.751 143.956 569.751C140.655 569.751 137.98 572.274 137.98 575.386C137.98 578.498 140.655 581.02 143.956 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M212.577 581.02C215.877 581.02 218.553 578.498 218.553 575.386C218.553 572.274 215.877 569.751 212.577 569.751C209.277 569.751 206.601 572.274 206.601 575.386C206.601 578.498 209.277 581.02 212.577 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M281.198 581.02C284.498 581.02 287.174 578.498 287.174 575.386C287.174 572.274 284.498 569.751 281.198 569.751C277.898 569.751 275.222 572.274 275.222 575.386C275.222 578.498 277.898 581.02 281.198 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M349.819 581.02C353.12 581.02 355.795 578.498 355.795 575.386C355.795 572.274 353.12 569.751 349.819 569.751C346.519 569.751 343.844 572.274 343.844 575.386C343.844 578.498 346.519 581.02 349.819 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M418.49 581.02C421.791 581.02 424.466 578.498 424.466 575.386C424.466 572.274 421.791 569.751 418.49 569.751C415.19 569.751 412.515 572.274 412.515 575.386C412.515 578.498 415.19 581.02 418.49 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M487.111 581.02C490.412 581.02 493.087 578.498 493.087 575.386C493.087 572.274 490.412 569.751 487.111 569.751C483.811 569.751 481.136 572.274 481.136 575.386C481.136 578.498 483.811 581.02 487.111 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M561.709 575.386C561.709 578.485 559.02 581.02 555.733 581.02C552.446 581.02 549.757 578.485 549.757 575.386C549.757 572.287 552.446 569.751 555.733 569.751C559.02 569.751 561.709 572.287 561.709 575.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M624.354 581.02C627.654 581.02 630.329 578.498 630.329 575.386C630.329 572.274 627.654 569.751 624.354 569.751C621.053 569.751 618.378 572.274 618.378 575.386C618.378 578.498 621.053 581.02 624.354 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M692.975 581.02C696.275 581.02 698.951 578.498 698.951 575.386C698.951 572.274 696.275 569.751 692.975 569.751C689.675 569.751 686.999 572.274 686.999 575.386C686.999 578.498 689.675 581.02 692.975 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M761.596 581.02C764.896 581.02 767.572 578.498 767.572 575.386C767.572 572.274 764.896 569.751 761.596 569.751C758.296 569.751 755.62 572.274 755.62 575.386C755.62 578.498 758.296 581.02 761.596 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M830.267 581.02C833.568 581.02 836.243 578.498 836.243 575.386C836.243 572.274 833.568 569.751 830.267 569.751C826.967 569.751 824.292 572.274 824.292 575.386C824.292 578.498 826.967 581.02 830.267 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M898.888 581.02C902.189 581.02 904.864 578.498 904.864 575.386C904.864 572.274 902.189 569.751 898.888 569.751C895.588 569.751 892.913 572.274 892.913 575.386C892.913 578.498 895.588 581.02 898.888 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M967.51 581.02C970.81 581.02 973.485 578.498 973.485 575.386C973.485 572.274 970.81 569.751 967.51 569.751C964.209 569.751 961.534 572.274 961.534 575.386C961.534 578.498 964.209 581.02 967.51 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M1036.13 581.02C1039.43 581.02 1042.11 578.498 1042.11 575.386C1042.11 572.274 1039.43 569.751 1036.13 569.751C1032.83 569.751 1030.16 572.274 1030.16 575.386C1030.16 578.498 1032.83 581.02 1036.13 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M1104.75 581.02C1108.05 581.02 1110.73 578.498 1110.73 575.386C1110.73 572.274 1108.05 569.751 1104.75 569.751C1101.45 569.751 1098.78 572.274 1098.78 575.386C1098.78 578.498 1101.45 581.02 1104.75 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M1173.37 581.02C1176.67 581.02 1179.35 578.498 1179.35 575.386C1179.35 572.274 1176.67 569.751 1173.37 569.751C1170.07 569.751 1167.4 572.274 1167.4 575.386C1167.4 578.498 1170.07 581.02 1173.37 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M1247.97 575.386C1247.97 578.485 1245.28 581.02 1241.99 581.02C1238.71 581.02 1236.02 578.485 1236.02 575.386C1236.02 572.287 1238.71 569.751 1241.99 569.751C1245.33 569.751 1247.97 572.287 1247.97 575.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M1310.67 581.02C1313.97 581.02 1316.64 578.498 1316.64 575.386C1316.64 572.274 1313.97 569.751 1310.67 569.751C1307.37 569.751 1304.69 572.274 1304.69 575.386C1304.69 578.498 1307.37 581.02 1310.67 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M1379.29 581.02C1382.59 581.02 1385.26 578.498 1385.26 575.386C1385.26 572.274 1382.59 569.751 1379.29 569.751C1375.99 569.751 1373.31 572.274 1373.31 575.386C1373.31 578.498 1375.99 581.02 1379.29 581.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M6.71325 644.316C10.0136 644.316 12.689 641.793 12.689 638.682C12.689 635.57 10.0136 633.047 6.71325 633.047C3.41295 633.047 0.737549 635.57 0.737549 638.682C0.737549 641.793 3.41295 644.316 6.71325 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M75.3346 644.316C78.6349 644.316 81.3103 641.793 81.3103 638.682C81.3103 635.57 78.6349 633.047 75.3346 633.047C72.0343 633.047 69.3589 635.57 69.3589 638.682C69.3589 641.793 72.0343 644.316 75.3346 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M143.956 644.316C147.256 644.316 149.931 641.793 149.931 638.682C149.931 635.57 147.256 633.047 143.956 633.047C140.655 633.047 137.98 635.57 137.98 638.682C137.98 641.793 140.655 644.316 143.956 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M212.577 644.316C215.877 644.316 218.553 641.793 218.553 638.682C218.553 635.57 215.877 633.047 212.577 633.047C209.277 633.047 206.601 635.57 206.601 638.682C206.601 641.793 209.277 644.316 212.577 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M281.198 644.316C284.498 644.316 287.174 641.793 287.174 638.682C287.174 635.57 284.498 633.047 281.198 633.047C277.898 633.047 275.222 635.57 275.222 638.682C275.222 641.793 277.898 644.316 281.198 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M349.819 644.316C353.12 644.316 355.795 641.793 355.795 638.682C355.795 635.57 353.12 633.047 349.819 633.047C346.519 633.047 343.844 635.57 343.844 638.682C343.844 641.793 346.519 644.316 349.819 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M418.49 644.316C421.791 644.316 424.466 641.793 424.466 638.682C424.466 635.57 421.791 633.047 418.49 633.047C415.19 633.047 412.515 635.57 412.515 638.682C412.515 641.793 415.19 644.316 418.49 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M487.111 644.316C490.412 644.316 493.087 641.793 493.087 638.682C493.087 635.57 490.412 633.047 487.111 633.047C483.811 633.047 481.136 635.57 481.136 638.682C481.136 641.793 483.811 644.316 487.111 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M561.709 638.682C561.709 641.781 559.02 644.316 555.733 644.316C552.446 644.316 549.757 641.781 549.757 638.682C549.757 635.582 552.446 633.047 555.733 633.047C559.02 633.047 561.709 635.582 561.709 638.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M624.354 644.316C627.654 644.316 630.329 641.793 630.329 638.682C630.329 635.57 627.654 633.047 624.354 633.047C621.053 633.047 618.378 635.57 618.378 638.682C618.378 641.793 621.053 644.316 624.354 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M692.975 644.316C696.275 644.316 698.951 641.793 698.951 638.682C698.951 635.57 696.275 633.047 692.975 633.047C689.675 633.047 686.999 635.57 686.999 638.682C686.999 641.793 689.675 644.316 692.975 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M761.596 644.316C764.896 644.316 767.572 641.793 767.572 638.682C767.572 635.57 764.896 633.047 761.596 633.047C758.296 633.047 755.62 635.57 755.62 638.682C755.62 641.793 758.296 644.316 761.596 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M830.267 644.316C833.568 644.316 836.243 641.793 836.243 638.682C836.243 635.57 833.568 633.047 830.267 633.047C826.967 633.047 824.292 635.57 824.292 638.682C824.292 641.793 826.967 644.316 830.267 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M898.888 644.316C902.189 644.316 904.864 641.793 904.864 638.682C904.864 635.57 902.189 633.047 898.888 633.047C895.588 633.047 892.913 635.57 892.913 638.682C892.913 641.793 895.588 644.316 898.888 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M967.51 644.316C970.81 644.316 973.485 641.793 973.485 638.682C973.485 635.57 970.81 633.047 967.51 633.047C964.209 633.047 961.534 635.57 961.534 638.682C961.534 641.793 964.209 644.316 967.51 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M1036.13 644.316C1039.43 644.316 1042.11 641.793 1042.11 638.682C1042.11 635.57 1039.43 633.047 1036.13 633.047C1032.83 633.047 1030.16 635.57 1030.16 638.682C1030.16 641.793 1032.83 644.316 1036.13 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M1104.75 644.316C1108.05 644.316 1110.73 641.793 1110.73 638.682C1110.73 635.57 1108.05 633.047 1104.75 633.047C1101.45 633.047 1098.78 635.57 1098.78 638.682C1098.78 641.793 1101.45 644.316 1104.75 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M1173.37 644.316C1176.67 644.316 1179.35 641.793 1179.35 638.682C1179.35 635.57 1176.67 633.047 1173.37 633.047C1170.07 633.047 1167.4 635.57 1167.4 638.682C1167.4 641.793 1170.07 644.316 1173.37 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M1247.97 638.682C1247.97 641.781 1245.28 644.316 1241.99 644.316C1238.71 644.316 1236.02 641.781 1236.02 638.682C1236.02 635.582 1238.71 633.047 1241.99 633.047C1245.33 633.047 1247.97 635.582 1247.97 638.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M1310.67 644.316C1313.97 644.316 1316.64 641.793 1316.64 638.682C1316.64 635.57 1313.97 633.047 1310.67 633.047C1307.37 633.047 1304.69 635.57 1304.69 638.682C1304.69 641.793 1307.37 644.316 1310.67 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M1379.29 644.316C1382.59 644.316 1385.26 641.793 1385.26 638.682C1385.26 635.57 1382.59 633.047 1379.29 633.047C1375.99 633.047 1373.31 635.57 1373.31 638.682C1373.31 641.793 1375.99 644.316 1379.29 644.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M6.71325 707.612C10.0136 707.612 12.689 705.089 12.689 701.977C12.689 698.865 10.0136 696.342 6.71325 696.342C3.41295 696.342 0.737549 698.865 0.737549 701.977C0.737549 705.089 3.41295 707.612 6.71325 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M75.3346 707.612C78.6349 707.612 81.3103 705.089 81.3103 701.977C81.3103 698.865 78.6349 696.342 75.3346 696.342C72.0343 696.342 69.3589 698.865 69.3589 701.977C69.3589 705.089 72.0343 707.612 75.3346 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M143.956 707.612C147.256 707.612 149.931 705.089 149.931 701.977C149.931 698.865 147.256 696.342 143.956 696.342C140.655 696.342 137.98 698.865 137.98 701.977C137.98 705.089 140.655 707.612 143.956 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M212.577 707.612C215.877 707.612 218.553 705.089 218.553 701.977C218.553 698.865 215.877 696.342 212.577 696.342C209.277 696.342 206.601 698.865 206.601 701.977C206.601 705.089 209.277 707.612 212.577 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M281.198 707.612C284.498 707.612 287.174 705.089 287.174 701.977C287.174 698.865 284.498 696.342 281.198 696.342C277.898 696.342 275.222 698.865 275.222 701.977C275.222 705.089 277.898 707.612 281.198 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M349.819 707.612C353.12 707.612 355.795 705.089 355.795 701.977C355.795 698.865 353.12 696.342 349.819 696.342C346.519 696.342 343.844 698.865 343.844 701.977C343.844 705.089 346.519 707.612 349.819 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M418.49 707.612C421.791 707.612 424.466 705.089 424.466 701.977C424.466 698.865 421.791 696.342 418.49 696.342C415.19 696.342 412.515 698.865 412.515 701.977C412.515 705.089 415.19 707.612 418.49 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M487.111 707.612C490.412 707.612 493.087 705.089 493.087 701.977C493.087 698.865 490.412 696.342 487.111 696.342C483.811 696.342 481.136 698.865 481.136 701.977C481.136 705.089 483.811 707.612 487.111 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M561.709 701.977C561.709 705.076 559.02 707.612 555.733 707.612C552.446 707.612 549.757 705.076 549.757 701.977C549.757 698.878 552.446 696.342 555.733 696.342C559.02 696.389 561.709 698.878 561.709 701.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M624.354 707.612C627.654 707.612 630.329 705.089 630.329 701.977C630.329 698.865 627.654 696.342 624.354 696.342C621.053 696.342 618.378 698.865 618.378 701.977C618.378 705.089 621.053 707.612 624.354 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M692.975 707.612C696.275 707.612 698.951 705.089 698.951 701.977C698.951 698.865 696.275 696.342 692.975 696.342C689.675 696.342 686.999 698.865 686.999 701.977C686.999 705.089 689.675 707.612 692.975 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M761.596 707.612C764.896 707.612 767.572 705.089 767.572 701.977C767.572 698.865 764.896 696.342 761.596 696.342C758.296 696.342 755.62 698.865 755.62 701.977C755.62 705.089 758.296 707.612 761.596 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M830.267 707.612C833.568 707.612 836.243 705.089 836.243 701.977C836.243 698.865 833.568 696.342 830.267 696.342C826.967 696.342 824.292 698.865 824.292 701.977C824.292 705.089 826.967 707.612 830.267 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M898.888 707.612C902.189 707.612 904.864 705.089 904.864 701.977C904.864 698.865 902.189 696.342 898.888 696.342C895.588 696.342 892.913 698.865 892.913 701.977C892.913 705.089 895.588 707.612 898.888 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M967.51 707.612C970.81 707.612 973.485 705.089 973.485 701.977C973.485 698.865 970.81 696.342 967.51 696.342C964.209 696.342 961.534 698.865 961.534 701.977C961.534 705.089 964.209 707.612 967.51 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M1036.13 707.612C1039.43 707.612 1042.11 705.089 1042.11 701.977C1042.11 698.865 1039.43 696.342 1036.13 696.342C1032.83 696.342 1030.16 698.865 1030.16 701.977C1030.16 705.089 1032.83 707.612 1036.13 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M1104.75 707.612C1108.05 707.612 1110.73 705.089 1110.73 701.977C1110.73 698.865 1108.05 696.342 1104.75 696.342C1101.45 696.342 1098.78 698.865 1098.78 701.977C1098.78 705.089 1101.45 707.612 1104.75 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M1173.37 707.612C1176.67 707.612 1179.35 705.089 1179.35 701.977C1179.35 698.865 1176.67 696.342 1173.37 696.342C1170.07 696.342 1167.4 698.865 1167.4 701.977C1167.4 705.089 1170.07 707.612 1173.37 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M1247.97 701.977C1247.97 705.076 1245.28 707.612 1241.99 707.612C1238.71 707.612 1236.02 705.076 1236.02 701.977C1236.02 698.878 1238.71 696.342 1241.99 696.342C1245.33 696.389 1247.97 698.878 1247.97 701.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M1310.67 707.612C1313.97 707.612 1316.64 705.089 1316.64 701.977C1316.64 698.865 1313.97 696.342 1310.67 696.342C1307.37 696.342 1304.69 698.865 1304.69 701.977C1304.69 705.089 1307.37 707.612 1310.67 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M1379.29 707.612C1382.59 707.612 1385.26 705.089 1385.26 701.977C1385.26 698.865 1382.59 696.342 1379.29 696.342C1375.99 696.342 1373.31 698.865 1373.31 701.977C1373.31 705.089 1375.99 707.612 1379.29 707.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M6.71325 770.954C10.0136 770.954 12.689 768.431 12.689 765.319C12.689 762.207 10.0136 759.685 6.71325 759.685C3.41295 759.685 0.737549 762.207 0.737549 765.319C0.737549 768.431 3.41295 770.954 6.71325 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M75.3346 770.954C78.6349 770.954 81.3103 768.431 81.3103 765.319C81.3103 762.207 78.6349 759.685 75.3346 759.685C72.0343 759.685 69.3589 762.207 69.3589 765.319C69.3589 768.431 72.0343 770.954 75.3346 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M143.956 770.954C147.256 770.954 149.931 768.431 149.931 765.319C149.931 762.207 147.256 759.685 143.956 759.685C140.655 759.685 137.98 762.207 137.98 765.319C137.98 768.431 140.655 770.954 143.956 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M212.577 770.954C215.877 770.954 218.553 768.431 218.553 765.319C218.553 762.207 215.877 759.685 212.577 759.685C209.277 759.685 206.601 762.207 206.601 765.319C206.601 768.431 209.277 770.954 212.577 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M281.198 770.954C284.498 770.954 287.174 768.431 287.174 765.319C287.174 762.207 284.498 759.685 281.198 759.685C277.898 759.685 275.222 762.207 275.222 765.319C275.222 768.431 277.898 770.954 281.198 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M349.819 770.954C353.12 770.954 355.795 768.431 355.795 765.319C355.795 762.207 353.12 759.685 349.819 759.685C346.519 759.685 343.844 762.207 343.844 765.319C343.844 768.431 346.519 770.954 349.819 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M418.49 770.954C421.791 770.954 424.466 768.431 424.466 765.319C424.466 762.207 421.791 759.685 418.49 759.685C415.19 759.685 412.515 762.207 412.515 765.319C412.515 768.431 415.19 770.954 418.49 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M487.111 770.954C490.412 770.954 493.087 768.431 493.087 765.319C493.087 762.207 490.412 759.685 487.111 759.685C483.811 759.685 481.136 762.207 481.136 765.319C481.136 768.431 483.811 770.954 487.111 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M561.709 765.319C561.709 768.418 559.02 770.954 555.733 770.954C552.446 770.954 549.757 768.418 549.757 765.319C549.757 762.22 552.446 759.685 555.733 759.685C559.02 759.685 561.709 762.173 561.709 765.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M624.354 770.954C627.654 770.954 630.329 768.431 630.329 765.319C630.329 762.207 627.654 759.685 624.354 759.685C621.053 759.685 618.378 762.207 618.378 765.319C618.378 768.431 621.053 770.954 624.354 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M692.975 770.954C696.275 770.954 698.951 768.431 698.951 765.319C698.951 762.207 696.275 759.685 692.975 759.685C689.675 759.685 686.999 762.207 686.999 765.319C686.999 768.431 689.675 770.954 692.975 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M761.596 770.954C764.896 770.954 767.572 768.431 767.572 765.319C767.572 762.207 764.896 759.685 761.596 759.685C758.296 759.685 755.62 762.207 755.62 765.319C755.62 768.431 758.296 770.954 761.596 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M830.267 770.954C833.568 770.954 836.243 768.431 836.243 765.319C836.243 762.207 833.568 759.685 830.267 759.685C826.967 759.685 824.292 762.207 824.292 765.319C824.292 768.431 826.967 770.954 830.267 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M898.888 770.954C902.189 770.954 904.864 768.431 904.864 765.319C904.864 762.207 902.189 759.685 898.888 759.685C895.588 759.685 892.913 762.207 892.913 765.319C892.913 768.431 895.588 770.954 898.888 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M967.51 770.954C970.81 770.954 973.485 768.431 973.485 765.319C973.485 762.207 970.81 759.685 967.51 759.685C964.209 759.685 961.534 762.207 961.534 765.319C961.534 768.431 964.209 770.954 967.51 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M1036.13 770.954C1039.43 770.954 1042.11 768.431 1042.11 765.319C1042.11 762.207 1039.43 759.685 1036.13 759.685C1032.83 759.685 1030.16 762.207 1030.16 765.319C1030.16 768.431 1032.83 770.954 1036.13 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M1104.75 770.954C1108.05 770.954 1110.73 768.431 1110.73 765.319C1110.73 762.207 1108.05 759.685 1104.75 759.685C1101.45 759.685 1098.78 762.207 1098.78 765.319C1098.78 768.431 1101.45 770.954 1104.75 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M1173.37 770.954C1176.67 770.954 1179.35 768.431 1179.35 765.319C1179.35 762.207 1176.67 759.685 1173.37 759.685C1170.07 759.685 1167.4 762.207 1167.4 765.319C1167.4 768.431 1170.07 770.954 1173.37 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M1247.97 765.319C1247.97 768.418 1245.28 770.954 1241.99 770.954C1238.71 770.954 1236.02 768.418 1236.02 765.319C1236.02 762.22 1238.71 759.685 1241.99 759.685C1245.33 759.685 1247.97 762.173 1247.97 765.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M1310.67 770.954C1313.97 770.954 1316.64 768.431 1316.64 765.319C1316.64 762.207 1313.97 759.685 1310.67 759.685C1307.37 759.685 1304.69 762.207 1304.69 765.319C1304.69 768.431 1307.37 770.954 1310.67 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M1379.29 770.954C1382.59 770.954 1385.26 768.431 1385.26 765.319C1385.26 762.207 1382.59 759.685 1379.29 759.685C1375.99 759.685 1373.31 762.207 1373.31 765.319C1373.31 768.431 1375.99 770.954 1379.29 770.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M6.71325 834.249C10.0136 834.249 12.689 831.726 12.689 828.614C12.689 825.502 10.0136 822.979 6.71325 822.979C3.41295 822.979 0.737549 825.502 0.737549 828.614C0.737549 831.726 3.41295 834.249 6.71325 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M75.3346 834.249C78.6349 834.249 81.3103 831.726 81.3103 828.614C81.3103 825.502 78.6349 822.979 75.3346 822.979C72.0343 822.979 69.3589 825.502 69.3589 828.614C69.3589 831.726 72.0343 834.249 75.3346 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M143.956 834.249C147.256 834.249 149.931 831.726 149.931 828.614C149.931 825.502 147.256 822.979 143.956 822.979C140.655 822.979 137.98 825.502 137.98 828.614C137.98 831.726 140.655 834.249 143.956 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M212.577 834.249C215.877 834.249 218.553 831.726 218.553 828.614C218.553 825.502 215.877 822.979 212.577 822.979C209.277 822.979 206.601 825.502 206.601 828.614C206.601 831.726 209.277 834.249 212.577 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M281.198 834.249C284.498 834.249 287.174 831.726 287.174 828.614C287.174 825.502 284.498 822.979 281.198 822.979C277.898 822.979 275.222 825.502 275.222 828.614C275.222 831.726 277.898 834.249 281.198 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M349.819 834.249C353.12 834.249 355.795 831.726 355.795 828.614C355.795 825.502 353.12 822.979 349.819 822.979C346.519 822.979 343.844 825.502 343.844 828.614C343.844 831.726 346.519 834.249 349.819 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M418.49 834.249C421.791 834.249 424.466 831.726 424.466 828.614C424.466 825.502 421.791 822.979 418.49 822.979C415.19 822.979 412.515 825.502 412.515 828.614C412.515 831.726 415.19 834.249 418.49 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M487.111 834.249C490.412 834.249 493.087 831.726 493.087 828.614C493.087 825.502 490.412 822.979 487.111 822.979C483.811 822.979 481.136 825.502 481.136 828.614C481.136 831.726 483.811 834.249 487.111 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M561.709 828.614C561.709 831.713 559.02 834.249 555.733 834.249C552.446 834.249 549.757 831.713 549.757 828.614C549.757 825.515 552.446 822.979 555.733 822.979C559.02 822.979 561.709 825.515 561.709 828.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M624.354 834.249C627.654 834.249 630.329 831.726 630.329 828.614C630.329 825.502 627.654 822.979 624.354 822.979C621.053 822.979 618.378 825.502 618.378 828.614C618.378 831.726 621.053 834.249 624.354 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M692.975 834.249C696.275 834.249 698.951 831.726 698.951 828.614C698.951 825.502 696.275 822.979 692.975 822.979C689.675 822.979 686.999 825.502 686.999 828.614C686.999 831.726 689.675 834.249 692.975 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M761.596 834.249C764.896 834.249 767.572 831.726 767.572 828.614C767.572 825.502 764.896 822.979 761.596 822.979C758.296 822.979 755.62 825.502 755.62 828.614C755.62 831.726 758.296 834.249 761.596 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M830.267 834.249C833.568 834.249 836.243 831.726 836.243 828.614C836.243 825.502 833.568 822.979 830.267 822.979C826.967 822.979 824.292 825.502 824.292 828.614C824.292 831.726 826.967 834.249 830.267 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M898.888 834.249C902.189 834.249 904.864 831.726 904.864 828.614C904.864 825.502 902.189 822.979 898.888 822.979C895.588 822.979 892.913 825.502 892.913 828.614C892.913 831.726 895.588 834.249 898.888 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M967.51 834.249C970.81 834.249 973.485 831.726 973.485 828.614C973.485 825.502 970.81 822.979 967.51 822.979C964.209 822.979 961.534 825.502 961.534 828.614C961.534 831.726 964.209 834.249 967.51 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M1036.13 834.249C1039.43 834.249 1042.11 831.726 1042.11 828.614C1042.11 825.502 1039.43 822.979 1036.13 822.979C1032.83 822.979 1030.16 825.502 1030.16 828.614C1030.16 831.726 1032.83 834.249 1036.13 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M1104.75 834.249C1108.05 834.249 1110.73 831.726 1110.73 828.614C1110.73 825.502 1108.05 822.979 1104.75 822.979C1101.45 822.979 1098.78 825.502 1098.78 828.614C1098.78 831.726 1101.45 834.249 1104.75 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M1173.37 834.249C1176.67 834.249 1179.35 831.726 1179.35 828.614C1179.35 825.502 1176.67 822.979 1173.37 822.979C1170.07 822.979 1167.4 825.502 1167.4 828.614C1167.4 831.726 1170.07 834.249 1173.37 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M1247.97 828.614C1247.97 831.713 1245.28 834.249 1241.99 834.249C1238.71 834.249 1236.02 831.713 1236.02 828.614C1236.02 825.515 1238.71 822.979 1241.99 822.979C1245.33 822.979 1247.97 825.515 1247.97 828.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M1310.67 834.249C1313.97 834.249 1316.64 831.726 1316.64 828.614C1316.64 825.502 1313.97 822.979 1310.67 822.979C1307.37 822.979 1304.69 825.502 1304.69 828.614C1304.69 831.726 1307.37 834.249 1310.67 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M1379.29 834.249C1382.59 834.249 1385.26 831.726 1385.26 828.614C1385.26 825.502 1382.59 822.979 1379.29 822.979C1375.99 822.979 1373.31 825.502 1373.31 828.614C1373.31 831.726 1375.99 834.249 1379.29 834.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M6.71325 897.544C10.0136 897.544 12.689 895.021 12.689 891.909C12.689 888.797 10.0136 886.275 6.71325 886.275C3.41295 886.275 0.737549 888.797 0.737549 891.909C0.737549 895.021 3.41295 897.544 6.71325 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M75.3346 897.544C78.6349 897.544 81.3103 895.021 81.3103 891.909C81.3103 888.797 78.6349 886.275 75.3346 886.275C72.0343 886.275 69.3589 888.797 69.3589 891.909C69.3589 895.021 72.0343 897.544 75.3346 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M143.956 897.544C147.256 897.544 149.931 895.021 149.931 891.909C149.931 888.797 147.256 886.275 143.956 886.275C140.655 886.275 137.98 888.797 137.98 891.909C137.98 895.021 140.655 897.544 143.956 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M212.577 897.544C215.877 897.544 218.553 895.021 218.553 891.909C218.553 888.797 215.877 886.275 212.577 886.275C209.277 886.275 206.601 888.797 206.601 891.909C206.601 895.021 209.277 897.544 212.577 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M281.198 897.544C284.498 897.544 287.174 895.021 287.174 891.909C287.174 888.797 284.498 886.275 281.198 886.275C277.898 886.275 275.222 888.797 275.222 891.909C275.222 895.021 277.898 897.544 281.198 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M349.819 897.544C353.12 897.544 355.795 895.021 355.795 891.909C355.795 888.797 353.12 886.275 349.819 886.275C346.519 886.275 343.844 888.797 343.844 891.909C343.844 895.021 346.519 897.544 349.819 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M418.49 897.544C421.791 897.544 424.466 895.021 424.466 891.909C424.466 888.797 421.791 886.275 418.49 886.275C415.19 886.275 412.515 888.797 412.515 891.909C412.515 895.021 415.19 897.544 418.49 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M487.111 897.544C490.412 897.544 493.087 895.021 493.087 891.909C493.087 888.797 490.412 886.275 487.111 886.275C483.811 886.275 481.136 888.797 481.136 891.909C481.136 895.021 483.811 897.544 487.111 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M561.709 891.909C561.709 895.008 559.02 897.544 555.733 897.544C552.446 897.544 549.757 895.008 549.757 891.909C549.757 888.81 552.446 886.275 555.733 886.275C559.02 886.275 561.709 888.81 561.709 891.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M624.354 897.544C627.654 897.544 630.329 895.021 630.329 891.909C630.329 888.797 627.654 886.275 624.354 886.275C621.053 886.275 618.378 888.797 618.378 891.909C618.378 895.021 621.053 897.544 624.354 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M692.975 897.544C696.275 897.544 698.951 895.021 698.951 891.909C698.951 888.797 696.275 886.275 692.975 886.275C689.675 886.275 686.999 888.797 686.999 891.909C686.999 895.021 689.675 897.544 692.975 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M761.596 897.544C764.896 897.544 767.572 895.021 767.572 891.909C767.572 888.797 764.896 886.275 761.596 886.275C758.296 886.275 755.62 888.797 755.62 891.909C755.62 895.021 758.296 897.544 761.596 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M830.267 897.544C833.568 897.544 836.243 895.021 836.243 891.909C836.243 888.797 833.568 886.275 830.267 886.275C826.967 886.275 824.292 888.797 824.292 891.909C824.292 895.021 826.967 897.544 830.267 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M898.888 897.544C902.189 897.544 904.864 895.021 904.864 891.909C904.864 888.797 902.189 886.275 898.888 886.275C895.588 886.275 892.913 888.797 892.913 891.909C892.913 895.021 895.588 897.544 898.888 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M967.51 897.544C970.81 897.544 973.485 895.021 973.485 891.909C973.485 888.797 970.81 886.275 967.51 886.275C964.209 886.275 961.534 888.797 961.534 891.909C961.534 895.021 964.209 897.544 967.51 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M1036.13 897.544C1039.43 897.544 1042.11 895.021 1042.11 891.909C1042.11 888.797 1039.43 886.275 1036.13 886.275C1032.83 886.275 1030.16 888.797 1030.16 891.909C1030.16 895.021 1032.83 897.544 1036.13 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M1104.75 897.544C1108.05 897.544 1110.73 895.021 1110.73 891.909C1110.73 888.797 1108.05 886.275 1104.75 886.275C1101.45 886.275 1098.78 888.797 1098.78 891.909C1098.78 895.021 1101.45 897.544 1104.75 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M1173.37 897.544C1176.67 897.544 1179.35 895.021 1179.35 891.909C1179.35 888.797 1176.67 886.275 1173.37 886.275C1170.07 886.275 1167.4 888.797 1167.4 891.909C1167.4 895.021 1170.07 897.544 1173.37 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M1247.97 891.909C1247.97 895.008 1245.28 897.544 1241.99 897.544C1238.71 897.544 1236.02 895.008 1236.02 891.909C1236.02 888.81 1238.71 886.275 1241.99 886.275C1245.33 886.275 1247.97 888.81 1247.97 891.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M1310.67 897.544C1313.97 897.544 1316.64 895.021 1316.64 891.909C1316.64 888.797 1313.97 886.275 1310.67 886.275C1307.37 886.275 1304.69 888.797 1304.69 891.909C1304.69 895.021 1307.37 897.544 1310.67 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M1379.29 897.544C1382.59 897.544 1385.26 895.021 1385.26 891.909C1385.26 888.797 1382.59 886.275 1379.29 886.275C1375.99 886.275 1373.31 888.797 1373.31 891.909C1373.31 895.021 1375.99 897.544 1379.29 897.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M6.71325 960.839C10.0136 960.839 12.689 958.316 12.689 955.204C12.689 952.092 10.0136 949.57 6.71325 949.57C3.41295 949.57 0.737549 952.092 0.737549 955.204C0.737549 958.316 3.41295 960.839 6.71325 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M75.3346 960.839C78.6349 960.839 81.3103 958.316 81.3103 955.204C81.3103 952.092 78.6349 949.57 75.3346 949.57C72.0343 949.57 69.3589 952.092 69.3589 955.204C69.3589 958.316 72.0343 960.839 75.3346 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M143.956 960.839C147.256 960.839 149.931 958.316 149.931 955.204C149.931 952.092 147.256 949.57 143.956 949.57C140.655 949.57 137.98 952.092 137.98 955.204C137.98 958.316 140.655 960.839 143.956 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M212.577 960.839C215.877 960.839 218.553 958.316 218.553 955.204C218.553 952.092 215.877 949.57 212.577 949.57C209.277 949.57 206.601 952.092 206.601 955.204C206.601 958.316 209.277 960.839 212.577 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M281.198 960.839C284.498 960.839 287.174 958.316 287.174 955.204C287.174 952.092 284.498 949.57 281.198 949.57C277.898 949.57 275.222 952.092 275.222 955.204C275.222 958.316 277.898 960.839 281.198 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M349.819 960.839C353.12 960.839 355.795 958.316 355.795 955.204C355.795 952.092 353.12 949.57 349.819 949.57C346.519 949.57 343.844 952.092 343.844 955.204C343.844 958.316 346.519 960.839 349.819 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M418.49 960.839C421.791 960.839 424.466 958.316 424.466 955.204C424.466 952.092 421.791 949.57 418.49 949.57C415.19 949.57 412.515 952.092 412.515 955.204C412.515 958.316 415.19 960.839 418.49 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M487.111 960.839C490.412 960.839 493.087 958.316 493.087 955.204C493.087 952.092 490.412 949.57 487.111 949.57C483.811 949.57 481.136 952.092 481.136 955.204C481.136 958.316 483.811 960.839 487.111 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M561.709 955.204C561.709 958.303 559.02 960.839 555.733 960.839C552.446 960.839 549.757 958.303 549.757 955.204C549.757 952.105 552.446 949.57 555.733 949.57C559.02 949.57 561.709 952.105 561.709 955.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M624.354 960.839C627.654 960.839 630.329 958.316 630.329 955.204C630.329 952.092 627.654 949.57 624.354 949.57C621.053 949.57 618.378 952.092 618.378 955.204C618.378 958.316 621.053 960.839 624.354 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M692.975 960.839C696.275 960.839 698.951 958.316 698.951 955.204C698.951 952.092 696.275 949.57 692.975 949.57C689.675 949.57 686.999 952.092 686.999 955.204C686.999 958.316 689.675 960.839 692.975 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M761.596 960.839C764.896 960.839 767.572 958.316 767.572 955.204C767.572 952.092 764.896 949.57 761.596 949.57C758.296 949.57 755.62 952.092 755.62 955.204C755.62 958.316 758.296 960.839 761.596 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M830.267 960.839C833.568 960.839 836.243 958.316 836.243 955.204C836.243 952.092 833.568 949.57 830.267 949.57C826.967 949.57 824.292 952.092 824.292 955.204C824.292 958.316 826.967 960.839 830.267 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M898.888 960.839C902.189 960.839 904.864 958.316 904.864 955.204C904.864 952.092 902.189 949.57 898.888 949.57C895.588 949.57 892.913 952.092 892.913 955.204C892.913 958.316 895.588 960.839 898.888 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M967.51 960.839C970.81 960.839 973.485 958.316 973.485 955.204C973.485 952.092 970.81 949.57 967.51 949.57C964.209 949.57 961.534 952.092 961.534 955.204C961.534 958.316 964.209 960.839 967.51 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M1036.13 960.839C1039.43 960.839 1042.11 958.316 1042.11 955.204C1042.11 952.092 1039.43 949.57 1036.13 949.57C1032.83 949.57 1030.16 952.092 1030.16 955.204C1030.16 958.316 1032.83 960.839 1036.13 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M1104.75 960.839C1108.05 960.839 1110.73 958.316 1110.73 955.204C1110.73 952.092 1108.05 949.57 1104.75 949.57C1101.45 949.57 1098.78 952.092 1098.78 955.204C1098.78 958.316 1101.45 960.839 1104.75 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M1173.37 960.839C1176.67 960.839 1179.35 958.316 1179.35 955.204C1179.35 952.092 1176.67 949.57 1173.37 949.57C1170.07 949.57 1167.4 952.092 1167.4 955.204C1167.4 958.316 1170.07 960.839 1173.37 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M1247.97 955.204C1247.97 958.303 1245.28 960.839 1241.99 960.839C1238.71 960.839 1236.02 958.303 1236.02 955.204C1236.02 952.105 1238.71 949.57 1241.99 949.57C1245.33 949.57 1247.97 952.105 1247.97 955.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M1310.67 960.839C1313.97 960.839 1316.64 958.316 1316.64 955.204C1316.64 952.092 1313.97 949.57 1310.67 949.57C1307.37 949.57 1304.69 952.092 1304.69 955.204C1304.69 958.316 1307.37 960.839 1310.67 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M1379.29 960.839C1382.59 960.839 1385.26 958.316 1385.26 955.204C1385.26 952.092 1382.59 949.57 1379.29 949.57C1375.99 949.57 1373.31 952.092 1373.31 955.204C1373.31 958.316 1375.99 960.839 1379.29 960.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M6.71325 1024.13C10.0136 1024.13 12.689 1021.61 12.689 1018.5C12.689 1015.39 10.0136 1012.87 6.71325 1012.87C3.41295 1012.87 0.737549 1015.39 0.737549 1018.5C0.737549 1021.61 3.41295 1024.13 6.71325 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M75.3346 1024.13C78.6349 1024.13 81.3103 1021.61 81.3103 1018.5C81.3103 1015.39 78.6349 1012.87 75.3346 1012.87C72.0343 1012.87 69.3589 1015.39 69.3589 1018.5C69.3589 1021.61 72.0343 1024.13 75.3346 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M143.956 1024.13C147.256 1024.13 149.931 1021.61 149.931 1018.5C149.931 1015.39 147.256 1012.87 143.956 1012.87C140.655 1012.87 137.98 1015.39 137.98 1018.5C137.98 1021.61 140.655 1024.13 143.956 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M212.577 1024.13C215.877 1024.13 218.553 1021.61 218.553 1018.5C218.553 1015.39 215.877 1012.87 212.577 1012.87C209.277 1012.87 206.601 1015.39 206.601 1018.5C206.601 1021.61 209.277 1024.13 212.577 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M281.198 1024.13C284.498 1024.13 287.174 1021.61 287.174 1018.5C287.174 1015.39 284.498 1012.87 281.198 1012.87C277.898 1012.87 275.222 1015.39 275.222 1018.5C275.222 1021.61 277.898 1024.13 281.198 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M349.819 1024.13C353.12 1024.13 355.795 1021.61 355.795 1018.5C355.795 1015.39 353.12 1012.87 349.819 1012.87C346.519 1012.87 343.844 1015.39 343.844 1018.5C343.844 1021.61 346.519 1024.13 349.819 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M418.49 1024.13C421.791 1024.13 424.466 1021.61 424.466 1018.5C424.466 1015.39 421.791 1012.87 418.49 1012.87C415.19 1012.87 412.515 1015.39 412.515 1018.5C412.515 1021.61 415.19 1024.13 418.49 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M487.111 1024.13C490.412 1024.13 493.087 1021.61 493.087 1018.5C493.087 1015.39 490.412 1012.87 487.111 1012.87C483.811 1012.87 481.136 1015.39 481.136 1018.5C481.136 1021.61 483.811 1024.13 487.111 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M561.709 1018.5C561.709 1021.6 559.02 1024.13 555.733 1024.13C552.446 1024.13 549.757 1021.6 549.757 1018.5C549.757 1015.4 552.446 1012.87 555.733 1012.87C559.02 1012.91 561.709 1015.4 561.709 1018.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M624.354 1024.13C627.654 1024.13 630.329 1021.61 630.329 1018.5C630.329 1015.39 627.654 1012.87 624.354 1012.87C621.053 1012.87 618.378 1015.39 618.378 1018.5C618.378 1021.61 621.053 1024.13 624.354 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M692.975 1024.13C696.275 1024.13 698.951 1021.61 698.951 1018.5C698.951 1015.39 696.275 1012.87 692.975 1012.87C689.675 1012.87 686.999 1015.39 686.999 1018.5C686.999 1021.61 689.675 1024.13 692.975 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M761.596 1024.13C764.896 1024.13 767.572 1021.61 767.572 1018.5C767.572 1015.39 764.896 1012.87 761.596 1012.87C758.296 1012.87 755.62 1015.39 755.62 1018.5C755.62 1021.61 758.296 1024.13 761.596 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M830.267 1024.13C833.568 1024.13 836.243 1021.61 836.243 1018.5C836.243 1015.39 833.568 1012.87 830.267 1012.87C826.967 1012.87 824.292 1015.39 824.292 1018.5C824.292 1021.61 826.967 1024.13 830.267 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M898.888 1024.13C902.189 1024.13 904.864 1021.61 904.864 1018.5C904.864 1015.39 902.189 1012.87 898.888 1012.87C895.588 1012.87 892.913 1015.39 892.913 1018.5C892.913 1021.61 895.588 1024.13 898.888 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M967.51 1024.13C970.81 1024.13 973.485 1021.61 973.485 1018.5C973.485 1015.39 970.81 1012.87 967.51 1012.87C964.209 1012.87 961.534 1015.39 961.534 1018.5C961.534 1021.61 964.209 1024.13 967.51 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M1036.13 1024.13C1039.43 1024.13 1042.11 1021.61 1042.11 1018.5C1042.11 1015.39 1039.43 1012.87 1036.13 1012.87C1032.83 1012.87 1030.16 1015.39 1030.16 1018.5C1030.16 1021.61 1032.83 1024.13 1036.13 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M1104.75 1024.13C1108.05 1024.13 1110.73 1021.61 1110.73 1018.5C1110.73 1015.39 1108.05 1012.87 1104.75 1012.87C1101.45 1012.87 1098.78 1015.39 1098.78 1018.5C1098.78 1021.61 1101.45 1024.13 1104.75 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M1173.37 1024.13C1176.67 1024.13 1179.35 1021.61 1179.35 1018.5C1179.35 1015.39 1176.67 1012.87 1173.37 1012.87C1170.07 1012.87 1167.4 1015.39 1167.4 1018.5C1167.4 1021.61 1170.07 1024.13 1173.37 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M1247.97 1018.5C1247.97 1021.6 1245.28 1024.13 1241.99 1024.13C1238.71 1024.13 1236.02 1021.6 1236.02 1018.5C1236.02 1015.4 1238.71 1012.87 1241.99 1012.87C1245.33 1012.91 1247.97 1015.4 1247.97 1018.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M1310.67 1024.13C1313.97 1024.13 1316.64 1021.61 1316.64 1018.5C1316.64 1015.39 1313.97 1012.87 1310.67 1012.87C1307.37 1012.87 1304.69 1015.39 1304.69 1018.5C1304.69 1021.61 1307.37 1024.13 1310.67 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M1379.29 1024.13C1382.59 1024.13 1385.26 1021.61 1385.26 1018.5C1385.26 1015.39 1382.59 1012.87 1379.29 1012.87C1375.99 1012.87 1373.31 1015.39 1373.31 1018.5C1373.31 1021.61 1375.99 1024.13 1379.29 1024.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M6.71325 1087.48C10.0136 1087.48 12.689 1084.95 12.689 1081.84C12.689 1078.73 10.0136 1076.21 6.71325 1076.21C3.41295 1076.21 0.737549 1078.73 0.737549 1081.84C0.737549 1084.95 3.41295 1087.48 6.71325 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M75.3346 1087.48C78.6349 1087.48 81.3103 1084.95 81.3103 1081.84C81.3103 1078.73 78.6349 1076.21 75.3346 1076.21C72.0343 1076.21 69.3589 1078.73 69.3589 1081.84C69.3589 1084.95 72.0343 1087.48 75.3346 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M143.956 1087.48C147.256 1087.48 149.931 1084.95 149.931 1081.84C149.931 1078.73 147.256 1076.21 143.956 1076.21C140.655 1076.21 137.98 1078.73 137.98 1081.84C137.98 1084.95 140.655 1087.48 143.956 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M212.577 1087.48C215.877 1087.48 218.553 1084.95 218.553 1081.84C218.553 1078.73 215.877 1076.21 212.577 1076.21C209.277 1076.21 206.601 1078.73 206.601 1081.84C206.601 1084.95 209.277 1087.48 212.577 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M281.198 1087.48C284.498 1087.48 287.174 1084.95 287.174 1081.84C287.174 1078.73 284.498 1076.21 281.198 1076.21C277.898 1076.21 275.222 1078.73 275.222 1081.84C275.222 1084.95 277.898 1087.48 281.198 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M349.819 1087.48C353.12 1087.48 355.795 1084.95 355.795 1081.84C355.795 1078.73 353.12 1076.21 349.819 1076.21C346.519 1076.21 343.844 1078.73 343.844 1081.84C343.844 1084.95 346.519 1087.48 349.819 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M418.49 1087.48C421.791 1087.48 424.466 1084.95 424.466 1081.84C424.466 1078.73 421.791 1076.21 418.49 1076.21C415.19 1076.21 412.515 1078.73 412.515 1081.84C412.515 1084.95 415.19 1087.48 418.49 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M487.111 1087.48C490.412 1087.48 493.087 1084.95 493.087 1081.84C493.087 1078.73 490.412 1076.21 487.111 1076.21C483.811 1076.21 481.136 1078.73 481.136 1081.84C481.136 1084.95 483.811 1087.48 487.111 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M561.709 1081.84C561.709 1084.94 559.02 1087.48 555.733 1087.48C552.446 1087.48 549.757 1084.94 549.757 1081.84C549.757 1078.74 552.446 1076.21 555.733 1076.21C559.02 1076.21 561.709 1078.7 561.709 1081.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M624.354 1087.48C627.654 1087.48 630.329 1084.95 630.329 1081.84C630.329 1078.73 627.654 1076.21 624.354 1076.21C621.053 1076.21 618.378 1078.73 618.378 1081.84C618.378 1084.95 621.053 1087.48 624.354 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M692.975 1087.48C696.275 1087.48 698.951 1084.95 698.951 1081.84C698.951 1078.73 696.275 1076.21 692.975 1076.21C689.675 1076.21 686.999 1078.73 686.999 1081.84C686.999 1084.95 689.675 1087.48 692.975 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M761.596 1087.48C764.896 1087.48 767.572 1084.95 767.572 1081.84C767.572 1078.73 764.896 1076.21 761.596 1076.21C758.296 1076.21 755.62 1078.73 755.62 1081.84C755.62 1084.95 758.296 1087.48 761.596 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M830.267 1087.48C833.568 1087.48 836.243 1084.95 836.243 1081.84C836.243 1078.73 833.568 1076.21 830.267 1076.21C826.967 1076.21 824.292 1078.73 824.292 1081.84C824.292 1084.95 826.967 1087.48 830.267 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M898.888 1087.48C902.189 1087.48 904.864 1084.95 904.864 1081.84C904.864 1078.73 902.189 1076.21 898.888 1076.21C895.588 1076.21 892.913 1078.73 892.913 1081.84C892.913 1084.95 895.588 1087.48 898.888 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M967.51 1087.48C970.81 1087.48 973.485 1084.95 973.485 1081.84C973.485 1078.73 970.81 1076.21 967.51 1076.21C964.209 1076.21 961.534 1078.73 961.534 1081.84C961.534 1084.95 964.209 1087.48 967.51 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M1036.13 1087.48C1039.43 1087.48 1042.11 1084.95 1042.11 1081.84C1042.11 1078.73 1039.43 1076.21 1036.13 1076.21C1032.83 1076.21 1030.16 1078.73 1030.16 1081.84C1030.16 1084.95 1032.83 1087.48 1036.13 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M1104.75 1087.48C1108.05 1087.48 1110.73 1084.95 1110.73 1081.84C1110.73 1078.73 1108.05 1076.21 1104.75 1076.21C1101.45 1076.21 1098.78 1078.73 1098.78 1081.84C1098.78 1084.95 1101.45 1087.48 1104.75 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M1173.37 1087.48C1176.67 1087.48 1179.35 1084.95 1179.35 1081.84C1179.35 1078.73 1176.67 1076.21 1173.37 1076.21C1170.07 1076.21 1167.4 1078.73 1167.4 1081.84C1167.4 1084.95 1170.07 1087.48 1173.37 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M1247.97 1081.84C1247.97 1084.94 1245.28 1087.48 1241.99 1087.48C1238.71 1087.48 1236.02 1084.94 1236.02 1081.84C1236.02 1078.74 1238.71 1076.21 1241.99 1076.21C1245.33 1076.21 1247.97 1078.7 1247.97 1081.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M1310.67 1087.48C1313.97 1087.48 1316.64 1084.95 1316.64 1081.84C1316.64 1078.73 1313.97 1076.21 1310.67 1076.21C1307.37 1076.21 1304.69 1078.73 1304.69 1081.84C1304.69 1084.95 1307.37 1087.48 1310.67 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M1379.29 1087.48C1382.59 1087.48 1385.26 1084.95 1385.26 1081.84C1385.26 1078.73 1382.59 1076.21 1379.29 1076.21C1375.99 1076.21 1373.31 1078.73 1373.31 1081.84C1373.31 1084.95 1375.99 1087.48 1379.29 1087.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M6.71325 1150.77C10.0136 1150.77 12.689 1148.25 12.689 1145.14C12.689 1142.03 10.0136 1139.5 6.71325 1139.5C3.41295 1139.5 0.737549 1142.03 0.737549 1145.14C0.737549 1148.25 3.41295 1150.77 6.71325 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M75.3346 1150.77C78.6349 1150.77 81.3103 1148.25 81.3103 1145.14C81.3103 1142.03 78.6349 1139.5 75.3346 1139.5C72.0343 1139.5 69.3589 1142.03 69.3589 1145.14C69.3589 1148.25 72.0343 1150.77 75.3346 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M143.956 1150.77C147.256 1150.77 149.931 1148.25 149.931 1145.14C149.931 1142.03 147.256 1139.5 143.956 1139.5C140.655 1139.5 137.98 1142.03 137.98 1145.14C137.98 1148.25 140.655 1150.77 143.956 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M212.577 1150.77C215.877 1150.77 218.553 1148.25 218.553 1145.14C218.553 1142.03 215.877 1139.5 212.577 1139.5C209.277 1139.5 206.601 1142.03 206.601 1145.14C206.601 1148.25 209.277 1150.77 212.577 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M281.198 1150.77C284.498 1150.77 287.174 1148.25 287.174 1145.14C287.174 1142.03 284.498 1139.5 281.198 1139.5C277.898 1139.5 275.222 1142.03 275.222 1145.14C275.222 1148.25 277.898 1150.77 281.198 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M349.819 1150.77C353.12 1150.77 355.795 1148.25 355.795 1145.14C355.795 1142.03 353.12 1139.5 349.819 1139.5C346.519 1139.5 343.844 1142.03 343.844 1145.14C343.844 1148.25 346.519 1150.77 349.819 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M418.49 1150.77C421.791 1150.77 424.466 1148.25 424.466 1145.14C424.466 1142.03 421.791 1139.5 418.49 1139.5C415.19 1139.5 412.515 1142.03 412.515 1145.14C412.515 1148.25 415.19 1150.77 418.49 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M487.111 1150.77C490.412 1150.77 493.087 1148.25 493.087 1145.14C493.087 1142.03 490.412 1139.5 487.111 1139.5C483.811 1139.5 481.136 1142.03 481.136 1145.14C481.136 1148.25 483.811 1150.77 487.111 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M561.709 1145.14C561.709 1148.24 559.02 1150.77 555.733 1150.77C552.446 1150.77 549.757 1148.24 549.757 1145.14C549.757 1142.04 552.446 1139.5 555.733 1139.5C559.02 1139.5 561.709 1142.04 561.709 1145.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M624.354 1150.77C627.654 1150.77 630.329 1148.25 630.329 1145.14C630.329 1142.03 627.654 1139.5 624.354 1139.5C621.053 1139.5 618.378 1142.03 618.378 1145.14C618.378 1148.25 621.053 1150.77 624.354 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M692.975 1150.77C696.275 1150.77 698.951 1148.25 698.951 1145.14C698.951 1142.03 696.275 1139.5 692.975 1139.5C689.675 1139.5 686.999 1142.03 686.999 1145.14C686.999 1148.25 689.675 1150.77 692.975 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M761.596 1150.77C764.896 1150.77 767.572 1148.25 767.572 1145.14C767.572 1142.03 764.896 1139.5 761.596 1139.5C758.296 1139.5 755.62 1142.03 755.62 1145.14C755.62 1148.25 758.296 1150.77 761.596 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M830.267 1150.77C833.568 1150.77 836.243 1148.25 836.243 1145.14C836.243 1142.03 833.568 1139.5 830.267 1139.5C826.967 1139.5 824.292 1142.03 824.292 1145.14C824.292 1148.25 826.967 1150.77 830.267 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M898.888 1150.77C902.189 1150.77 904.864 1148.25 904.864 1145.14C904.864 1142.03 902.189 1139.5 898.888 1139.5C895.588 1139.5 892.913 1142.03 892.913 1145.14C892.913 1148.25 895.588 1150.77 898.888 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M967.51 1150.77C970.81 1150.77 973.485 1148.25 973.485 1145.14C973.485 1142.03 970.81 1139.5 967.51 1139.5C964.209 1139.5 961.534 1142.03 961.534 1145.14C961.534 1148.25 964.209 1150.77 967.51 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M1036.13 1150.77C1039.43 1150.77 1042.11 1148.25 1042.11 1145.14C1042.11 1142.03 1039.43 1139.5 1036.13 1139.5C1032.83 1139.5 1030.16 1142.03 1030.16 1145.14C1030.16 1148.25 1032.83 1150.77 1036.13 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M1104.75 1150.77C1108.05 1150.77 1110.73 1148.25 1110.73 1145.14C1110.73 1142.03 1108.05 1139.5 1104.75 1139.5C1101.45 1139.5 1098.78 1142.03 1098.78 1145.14C1098.78 1148.25 1101.45 1150.77 1104.75 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M1173.37 1150.77C1176.67 1150.77 1179.35 1148.25 1179.35 1145.14C1179.35 1142.03 1176.67 1139.5 1173.37 1139.5C1170.07 1139.5 1167.4 1142.03 1167.4 1145.14C1167.4 1148.25 1170.07 1150.77 1173.37 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M1247.97 1145.14C1247.97 1148.24 1245.28 1150.77 1241.99 1150.77C1238.71 1150.77 1236.02 1148.24 1236.02 1145.14C1236.02 1142.04 1238.71 1139.5 1241.99 1139.5C1245.33 1139.5 1247.97 1142.04 1247.97 1145.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M1310.67 1150.77C1313.97 1150.77 1316.64 1148.25 1316.64 1145.14C1316.64 1142.03 1313.97 1139.5 1310.67 1139.5C1307.37 1139.5 1304.69 1142.03 1304.69 1145.14C1304.69 1148.25 1307.37 1150.77 1310.67 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M1379.29 1150.77C1382.59 1150.77 1385.26 1148.25 1385.26 1145.14C1385.26 1142.03 1382.59 1139.5 1379.29 1139.5C1375.99 1139.5 1373.31 1142.03 1373.31 1145.14C1373.31 1148.25 1375.99 1150.77 1379.29 1150.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M6.71325 1214.07C10.0136 1214.07 12.689 1211.55 12.689 1208.43C12.689 1205.32 10.0136 1202.8 6.71325 1202.8C3.41295 1202.8 0.737549 1205.32 0.737549 1208.43C0.737549 1211.55 3.41295 1214.07 6.71325 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M75.3346 1214.07C78.6349 1214.07 81.3103 1211.55 81.3103 1208.43C81.3103 1205.32 78.6349 1202.8 75.3346 1202.8C72.0343 1202.8 69.3589 1205.32 69.3589 1208.43C69.3589 1211.55 72.0343 1214.07 75.3346 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M143.956 1214.07C147.256 1214.07 149.931 1211.55 149.931 1208.43C149.931 1205.32 147.256 1202.8 143.956 1202.8C140.655 1202.8 137.98 1205.32 137.98 1208.43C137.98 1211.55 140.655 1214.07 143.956 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M212.577 1214.07C215.877 1214.07 218.553 1211.55 218.553 1208.43C218.553 1205.32 215.877 1202.8 212.577 1202.8C209.277 1202.8 206.601 1205.32 206.601 1208.43C206.601 1211.55 209.277 1214.07 212.577 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M281.198 1214.07C284.498 1214.07 287.174 1211.55 287.174 1208.43C287.174 1205.32 284.498 1202.8 281.198 1202.8C277.898 1202.8 275.222 1205.32 275.222 1208.43C275.222 1211.55 277.898 1214.07 281.198 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M349.819 1214.07C353.12 1214.07 355.795 1211.55 355.795 1208.43C355.795 1205.32 353.12 1202.8 349.819 1202.8C346.519 1202.8 343.844 1205.32 343.844 1208.43C343.844 1211.55 346.519 1214.07 349.819 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M418.49 1214.07C421.791 1214.07 424.466 1211.55 424.466 1208.43C424.466 1205.32 421.791 1202.8 418.49 1202.8C415.19 1202.8 412.515 1205.32 412.515 1208.43C412.515 1211.55 415.19 1214.07 418.49 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M487.111 1214.07C490.412 1214.07 493.087 1211.55 493.087 1208.43C493.087 1205.32 490.412 1202.8 487.111 1202.8C483.811 1202.8 481.136 1205.32 481.136 1208.43C481.136 1211.55 483.811 1214.07 487.111 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M561.709 1208.43C561.709 1211.53 559.02 1214.07 555.733 1214.07C552.446 1214.07 549.757 1211.53 549.757 1208.43C549.757 1205.33 552.446 1202.8 555.733 1202.8C559.02 1202.8 561.709 1205.33 561.709 1208.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M624.354 1214.07C627.654 1214.07 630.329 1211.55 630.329 1208.43C630.329 1205.32 627.654 1202.8 624.354 1202.8C621.053 1202.8 618.378 1205.32 618.378 1208.43C618.378 1211.55 621.053 1214.07 624.354 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M692.975 1214.07C696.275 1214.07 698.951 1211.55 698.951 1208.43C698.951 1205.32 696.275 1202.8 692.975 1202.8C689.675 1202.8 686.999 1205.32 686.999 1208.43C686.999 1211.55 689.675 1214.07 692.975 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M761.596 1214.07C764.896 1214.07 767.572 1211.55 767.572 1208.43C767.572 1205.32 764.896 1202.8 761.596 1202.8C758.296 1202.8 755.62 1205.32 755.62 1208.43C755.62 1211.55 758.296 1214.07 761.596 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M830.267 1214.07C833.568 1214.07 836.243 1211.55 836.243 1208.43C836.243 1205.32 833.568 1202.8 830.267 1202.8C826.967 1202.8 824.292 1205.32 824.292 1208.43C824.292 1211.55 826.967 1214.07 830.267 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M898.888 1214.07C902.189 1214.07 904.864 1211.55 904.864 1208.43C904.864 1205.32 902.189 1202.8 898.888 1202.8C895.588 1202.8 892.913 1205.32 892.913 1208.43C892.913 1211.55 895.588 1214.07 898.888 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M967.51 1214.07C970.81 1214.07 973.485 1211.55 973.485 1208.43C973.485 1205.32 970.81 1202.8 967.51 1202.8C964.209 1202.8 961.534 1205.32 961.534 1208.43C961.534 1211.55 964.209 1214.07 967.51 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M1036.13 1214.07C1039.43 1214.07 1042.11 1211.55 1042.11 1208.43C1042.11 1205.32 1039.43 1202.8 1036.13 1202.8C1032.83 1202.8 1030.16 1205.32 1030.16 1208.43C1030.16 1211.55 1032.83 1214.07 1036.13 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M1104.75 1214.07C1108.05 1214.07 1110.73 1211.55 1110.73 1208.43C1110.73 1205.32 1108.05 1202.8 1104.75 1202.8C1101.45 1202.8 1098.78 1205.32 1098.78 1208.43C1098.78 1211.55 1101.45 1214.07 1104.75 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M1173.37 1214.07C1176.67 1214.07 1179.35 1211.55 1179.35 1208.43C1179.35 1205.32 1176.67 1202.8 1173.37 1202.8C1170.07 1202.8 1167.4 1205.32 1167.4 1208.43C1167.4 1211.55 1170.07 1214.07 1173.37 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M1247.97 1208.43C1247.97 1211.53 1245.28 1214.07 1241.99 1214.07C1238.71 1214.07 1236.02 1211.53 1236.02 1208.43C1236.02 1205.33 1238.71 1202.8 1241.99 1202.8C1245.33 1202.8 1247.97 1205.33 1247.97 1208.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M1310.67 1214.07C1313.97 1214.07 1316.64 1211.55 1316.64 1208.43C1316.64 1205.32 1313.97 1202.8 1310.67 1202.8C1307.37 1202.8 1304.69 1205.32 1304.69 1208.43C1304.69 1211.55 1307.37 1214.07 1310.67 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M1379.29 1214.07C1382.59 1214.07 1385.26 1211.55 1385.26 1208.43C1385.26 1205.32 1382.59 1202.8 1379.29 1202.8C1375.99 1202.8 1373.31 1205.32 1373.31 1208.43C1373.31 1211.55 1375.99 1214.07 1379.29 1214.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M6.71325 1277.36C10.0136 1277.36 12.689 1274.84 12.689 1271.73C12.689 1268.62 10.0136 1266.09 6.71325 1266.09C3.41295 1266.09 0.737549 1268.62 0.737549 1271.73C0.737549 1274.84 3.41295 1277.36 6.71325 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M75.3346 1277.36C78.6349 1277.36 81.3103 1274.84 81.3103 1271.73C81.3103 1268.62 78.6349 1266.09 75.3346 1266.09C72.0343 1266.09 69.3589 1268.62 69.3589 1271.73C69.3589 1274.84 72.0343 1277.36 75.3346 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M143.956 1277.36C147.256 1277.36 149.931 1274.84 149.931 1271.73C149.931 1268.62 147.256 1266.09 143.956 1266.09C140.655 1266.09 137.98 1268.62 137.98 1271.73C137.98 1274.84 140.655 1277.36 143.956 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M212.577 1277.36C215.877 1277.36 218.553 1274.84 218.553 1271.73C218.553 1268.62 215.877 1266.09 212.577 1266.09C209.277 1266.09 206.601 1268.62 206.601 1271.73C206.601 1274.84 209.277 1277.36 212.577 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M281.198 1277.36C284.498 1277.36 287.174 1274.84 287.174 1271.73C287.174 1268.62 284.498 1266.09 281.198 1266.09C277.898 1266.09 275.222 1268.62 275.222 1271.73C275.222 1274.84 277.898 1277.36 281.198 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M349.819 1277.36C353.12 1277.36 355.795 1274.84 355.795 1271.73C355.795 1268.62 353.12 1266.09 349.819 1266.09C346.519 1266.09 343.844 1268.62 343.844 1271.73C343.844 1274.84 346.519 1277.36 349.819 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M418.49 1277.36C421.791 1277.36 424.466 1274.84 424.466 1271.73C424.466 1268.62 421.791 1266.09 418.49 1266.09C415.19 1266.09 412.515 1268.62 412.515 1271.73C412.515 1274.84 415.19 1277.36 418.49 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M487.111 1277.36C490.412 1277.36 493.087 1274.84 493.087 1271.73C493.087 1268.62 490.412 1266.09 487.111 1266.09C483.811 1266.09 481.136 1268.62 481.136 1271.73C481.136 1274.84 483.811 1277.36 487.111 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M561.709 1271.73C561.709 1274.83 559.02 1277.36 555.733 1277.36C552.446 1277.36 549.757 1274.83 549.757 1271.73C549.757 1268.63 552.446 1266.09 555.733 1266.09C559.02 1266.09 561.709 1268.63 561.709 1271.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M624.354 1277.36C627.654 1277.36 630.329 1274.84 630.329 1271.73C630.329 1268.62 627.654 1266.09 624.354 1266.09C621.053 1266.09 618.378 1268.62 618.378 1271.73C618.378 1274.84 621.053 1277.36 624.354 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M692.975 1277.36C696.275 1277.36 698.951 1274.84 698.951 1271.73C698.951 1268.62 696.275 1266.09 692.975 1266.09C689.675 1266.09 686.999 1268.62 686.999 1271.73C686.999 1274.84 689.675 1277.36 692.975 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M761.596 1277.36C764.896 1277.36 767.572 1274.84 767.572 1271.73C767.572 1268.62 764.896 1266.09 761.596 1266.09C758.296 1266.09 755.62 1268.62 755.62 1271.73C755.62 1274.84 758.296 1277.36 761.596 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M830.267 1277.36C833.568 1277.36 836.243 1274.84 836.243 1271.73C836.243 1268.62 833.568 1266.09 830.267 1266.09C826.967 1266.09 824.292 1268.62 824.292 1271.73C824.292 1274.84 826.967 1277.36 830.267 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M898.888 1277.36C902.189 1277.36 904.864 1274.84 904.864 1271.73C904.864 1268.62 902.189 1266.09 898.888 1266.09C895.588 1266.09 892.913 1268.62 892.913 1271.73C892.913 1274.84 895.588 1277.36 898.888 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M967.51 1277.36C970.81 1277.36 973.485 1274.84 973.485 1271.73C973.485 1268.62 970.81 1266.09 967.51 1266.09C964.209 1266.09 961.534 1268.62 961.534 1271.73C961.534 1274.84 964.209 1277.36 967.51 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M1036.13 1277.36C1039.43 1277.36 1042.11 1274.84 1042.11 1271.73C1042.11 1268.62 1039.43 1266.09 1036.13 1266.09C1032.83 1266.09 1030.16 1268.62 1030.16 1271.73C1030.16 1274.84 1032.83 1277.36 1036.13 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M1104.75 1277.36C1108.05 1277.36 1110.73 1274.84 1110.73 1271.73C1110.73 1268.62 1108.05 1266.09 1104.75 1266.09C1101.45 1266.09 1098.78 1268.62 1098.78 1271.73C1098.78 1274.84 1101.45 1277.36 1104.75 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M1173.37 1277.36C1176.67 1277.36 1179.35 1274.84 1179.35 1271.73C1179.35 1268.62 1176.67 1266.09 1173.37 1266.09C1170.07 1266.09 1167.4 1268.62 1167.4 1271.73C1167.4 1274.84 1170.07 1277.36 1173.37 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M1247.97 1271.73C1247.97 1274.83 1245.28 1277.36 1241.99 1277.36C1238.71 1277.36 1236.02 1274.83 1236.02 1271.73C1236.02 1268.63 1238.71 1266.09 1241.99 1266.09C1245.33 1266.09 1247.97 1268.63 1247.97 1271.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M1310.67 1277.36C1313.97 1277.36 1316.64 1274.84 1316.64 1271.73C1316.64 1268.62 1313.97 1266.09 1310.67 1266.09C1307.37 1266.09 1304.69 1268.62 1304.69 1271.73C1304.69 1274.84 1307.37 1277.36 1310.67 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M1379.29 1277.36C1382.59 1277.36 1385.26 1274.84 1385.26 1271.73C1385.26 1268.62 1382.59 1266.09 1379.29 1266.09C1375.99 1266.09 1373.31 1268.62 1373.31 1271.73C1373.31 1274.84 1375.99 1277.36 1379.29 1277.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M12.689 1335.02C12.689 1338.12 9.9999 1340.66 6.71325 1340.66C3.42661 1340.66 0.737549 1338.12 0.737549 1335.02C0.737549 1331.93 3.42661 1329.39 6.71325 1329.39C9.9999 1329.44 12.689 1331.93 12.689 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M81.3103 1335.02C81.3103 1338.12 78.6212 1340.66 75.3346 1340.66C72.0479 1340.66 69.3589 1338.12 69.3589 1335.02C69.3589 1331.93 72.0479 1329.39 75.3346 1329.39C78.6212 1329.44 81.3103 1331.93 81.3103 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M149.931 1335.02C149.931 1338.12 147.242 1340.66 143.956 1340.66C140.669 1340.66 137.98 1338.12 137.98 1335.02C137.98 1331.93 140.669 1329.39 143.956 1329.39C147.242 1329.44 149.931 1331.93 149.931 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M218.553 1335.02C218.553 1338.12 215.864 1340.66 212.577 1340.66C209.29 1340.66 206.601 1338.12 206.601 1335.02C206.601 1331.93 209.29 1329.39 212.577 1329.39C215.864 1329.44 218.553 1331.93 218.553 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M287.174 1335.02C287.174 1338.12 284.485 1340.66 281.198 1340.66C277.911 1340.66 275.222 1338.12 275.222 1335.02C275.222 1331.93 277.911 1329.39 281.198 1329.39C284.485 1329.44 287.174 1331.93 287.174 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M355.795 1335.02C355.795 1338.12 353.106 1340.66 349.819 1340.66C346.533 1340.66 343.844 1338.12 343.844 1335.02C343.844 1331.93 346.533 1329.39 349.819 1329.39C353.156 1329.44 355.795 1331.93 355.795 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M424.416 1335.02C424.416 1338.12 421.727 1340.66 418.44 1340.66C415.154 1340.66 412.465 1338.12 412.465 1335.02C412.465 1331.93 415.154 1329.39 418.44 1329.39C421.777 1329.44 424.416 1331.93 424.416 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M493.087 1335.02C493.087 1338.12 490.398 1340.66 487.111 1340.66C483.825 1340.66 481.136 1338.12 481.136 1335.02C481.136 1331.93 483.825 1329.39 487.111 1329.39C490.398 1329.39 493.087 1331.93 493.087 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M561.709 1335.02C561.709 1338.12 559.02 1340.66 555.733 1340.66C552.446 1340.66 549.757 1338.12 549.757 1335.02C549.757 1331.93 552.446 1329.39 555.733 1329.39C559.02 1329.44 561.709 1331.93 561.709 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M630.329 1335.02C630.329 1338.12 627.64 1340.66 624.354 1340.66C621.067 1340.66 618.378 1338.12 618.378 1335.02C618.378 1331.93 621.067 1329.39 624.354 1329.39C627.64 1329.44 630.329 1331.93 630.329 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M698.951 1335.02C698.951 1338.12 696.262 1340.66 692.975 1340.66C689.689 1340.66 686.999 1338.12 686.999 1335.02C686.999 1331.93 689.689 1329.39 692.975 1329.39C696.262 1329.44 698.951 1331.93 698.951 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M767.572 1335.02C767.572 1338.12 764.883 1340.66 761.596 1340.66C758.309 1340.66 755.62 1338.12 755.62 1335.02C755.62 1331.93 758.309 1329.39 761.596 1329.39C764.933 1329.44 767.572 1331.93 767.572 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M836.193 1335.02C836.193 1338.12 833.504 1340.66 830.217 1340.66C826.931 1340.66 824.242 1338.12 824.242 1335.02C824.242 1331.93 826.931 1329.39 830.217 1329.39C833.554 1329.44 836.193 1331.93 836.193 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M904.864 1335.02C904.864 1338.12 902.175 1340.66 898.888 1340.66C895.602 1340.66 892.913 1338.12 892.913 1335.02C892.913 1331.93 895.602 1329.39 898.888 1329.39C902.175 1329.44 904.864 1331.93 904.864 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M973.485 1335.02C973.485 1338.12 970.796 1340.66 967.51 1340.66C964.223 1340.66 961.534 1338.12 961.534 1335.02C961.534 1331.93 964.223 1329.39 967.51 1329.39C970.796 1329.39 973.485 1331.93 973.485 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M1042.11 1335.02C1042.11 1338.12 1039.42 1340.66 1036.13 1340.66C1032.84 1340.66 1030.16 1338.12 1030.16 1335.02C1030.16 1331.93 1032.84 1329.39 1036.13 1329.39C1039.42 1329.44 1042.11 1331.93 1042.11 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M1110.73 1335.02C1110.73 1338.12 1108.04 1340.66 1104.75 1340.66C1101.47 1340.66 1098.78 1338.12 1098.78 1335.02C1098.78 1331.93 1101.47 1329.39 1104.75 1329.39C1108.04 1329.44 1110.73 1331.93 1110.73 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M1179.35 1335.02C1179.35 1338.12 1176.66 1340.66 1173.37 1340.66C1170.09 1340.66 1167.4 1338.12 1167.4 1335.02C1167.4 1331.93 1170.09 1329.39 1173.37 1329.39C1176.71 1329.44 1179.35 1331.93 1179.35 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M1247.97 1335.02C1247.97 1338.12 1245.28 1340.66 1241.99 1340.66C1238.71 1340.66 1236.02 1338.12 1236.02 1335.02C1236.02 1331.93 1238.71 1329.39 1241.99 1329.39C1245.33 1329.44 1247.97 1331.93 1247.97 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M1316.64 1335.02C1316.64 1338.12 1313.95 1340.66 1310.67 1340.66C1307.38 1340.66 1304.69 1338.12 1304.69 1335.02C1304.69 1331.93 1307.38 1329.39 1310.67 1329.39C1313.95 1329.44 1316.64 1331.93 1316.64 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M1385.26 1335.02C1385.26 1338.12 1382.57 1340.66 1379.29 1340.66C1376 1340.66 1373.31 1338.12 1373.31 1335.02C1373.31 1331.93 1376 1329.39 1379.29 1329.39C1382.57 1329.44 1385.26 1331.93 1385.26 1335.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M6.71325 1404C10.0136 1404 12.689 1401.48 12.689 1398.37C12.689 1395.25 10.0136 1392.73 6.71325 1392.73C3.41295 1392.73 0.737549 1395.25 0.737549 1398.37C0.737549 1401.48 3.41295 1404 6.71325 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M75.3346 1404C78.6349 1404 81.3103 1401.48 81.3103 1398.37C81.3103 1395.25 78.6349 1392.73 75.3346 1392.73C72.0343 1392.73 69.3589 1395.25 69.3589 1398.37C69.3589 1401.48 72.0343 1404 75.3346 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M143.956 1404C147.256 1404 149.931 1401.48 149.931 1398.37C149.931 1395.25 147.256 1392.73 143.956 1392.73C140.655 1392.73 137.98 1395.25 137.98 1398.37C137.98 1401.48 140.655 1404 143.956 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M212.577 1404C215.877 1404 218.553 1401.48 218.553 1398.37C218.553 1395.25 215.877 1392.73 212.577 1392.73C209.277 1392.73 206.601 1395.25 206.601 1398.37C206.601 1401.48 209.277 1404 212.577 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M281.198 1404C284.498 1404 287.174 1401.48 287.174 1398.37C287.174 1395.25 284.498 1392.73 281.198 1392.73C277.898 1392.73 275.222 1395.25 275.222 1398.37C275.222 1401.48 277.898 1404 281.198 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M349.819 1404C353.12 1404 355.795 1401.48 355.795 1398.37C355.795 1395.25 353.12 1392.73 349.819 1392.73C346.519 1392.73 343.844 1395.25 343.844 1398.37C343.844 1401.48 346.519 1404 349.819 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M418.49 1404C421.791 1404 424.466 1401.48 424.466 1398.37C424.466 1395.25 421.791 1392.73 418.49 1392.73C415.19 1392.73 412.515 1395.25 412.515 1398.37C412.515 1401.48 415.19 1404 418.49 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M487.111 1404C490.412 1404 493.087 1401.48 493.087 1398.37C493.087 1395.25 490.412 1392.73 487.111 1392.73C483.811 1392.73 481.136 1395.25 481.136 1398.37C481.136 1401.48 483.811 1404 487.111 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M561.709 1398.37C561.709 1401.46 559.02 1404 555.733 1404C552.446 1404 549.757 1401.46 549.757 1398.37C549.757 1395.27 552.446 1392.73 555.733 1392.73C559.02 1392.73 561.709 1395.22 561.709 1398.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M624.354 1404C627.654 1404 630.329 1401.48 630.329 1398.37C630.329 1395.25 627.654 1392.73 624.354 1392.73C621.053 1392.73 618.378 1395.25 618.378 1398.37C618.378 1401.48 621.053 1404 624.354 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M692.975 1404C696.275 1404 698.951 1401.48 698.951 1398.37C698.951 1395.25 696.275 1392.73 692.975 1392.73C689.675 1392.73 686.999 1395.25 686.999 1398.37C686.999 1401.48 689.675 1404 692.975 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M761.596 1404C764.896 1404 767.572 1401.48 767.572 1398.37C767.572 1395.25 764.896 1392.73 761.596 1392.73C758.296 1392.73 755.62 1395.25 755.62 1398.37C755.62 1401.48 758.296 1404 761.596 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M830.267 1404C833.568 1404 836.243 1401.48 836.243 1398.37C836.243 1395.25 833.568 1392.73 830.267 1392.73C826.967 1392.73 824.292 1395.25 824.292 1398.37C824.292 1401.48 826.967 1404 830.267 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M898.888 1404C902.189 1404 904.864 1401.48 904.864 1398.37C904.864 1395.25 902.189 1392.73 898.888 1392.73C895.588 1392.73 892.913 1395.25 892.913 1398.37C892.913 1401.48 895.588 1404 898.888 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M967.51 1404C970.81 1404 973.485 1401.48 973.485 1398.37C973.485 1395.25 970.81 1392.73 967.51 1392.73C964.209 1392.73 961.534 1395.25 961.534 1398.37C961.534 1401.48 964.209 1404 967.51 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M1036.13 1404C1039.43 1404 1042.11 1401.48 1042.11 1398.37C1042.11 1395.25 1039.43 1392.73 1036.13 1392.73C1032.83 1392.73 1030.16 1395.25 1030.16 1398.37C1030.16 1401.48 1032.83 1404 1036.13 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M1104.75 1404C1108.05 1404 1110.73 1401.48 1110.73 1398.37C1110.73 1395.25 1108.05 1392.73 1104.75 1392.73C1101.45 1392.73 1098.78 1395.25 1098.78 1398.37C1098.78 1401.48 1101.45 1404 1104.75 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M1173.37 1404C1176.67 1404 1179.35 1401.48 1179.35 1398.37C1179.35 1395.25 1176.67 1392.73 1173.37 1392.73C1170.07 1392.73 1167.4 1395.25 1167.4 1398.37C1167.4 1401.48 1170.07 1404 1173.37 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M1247.97 1398.37C1247.97 1401.46 1245.28 1404 1241.99 1404C1238.71 1404 1236.02 1401.46 1236.02 1398.37C1236.02 1395.27 1238.71 1392.73 1241.99 1392.73C1245.33 1392.73 1247.97 1395.22 1247.97 1398.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M1310.67 1404C1313.97 1404 1316.64 1401.48 1316.64 1398.37C1316.64 1395.25 1313.97 1392.73 1310.67 1392.73C1307.37 1392.73 1304.69 1395.25 1304.69 1398.37C1304.69 1401.48 1307.37 1404 1310.67 1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M1379.29 1404C1382.59 1404 1385.26 1401.48 1385.26 1398.37C1385.26 1395.25 1382.59 1392.73 1379.29 1392.73C1375.99 1392.73 1373.31 1395.25 1373.31 1398.37C1373.31 1401.48 1375.99 1404 1379.29 1404Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.128f5e9cae1cb6ee46acbbd4d82b6d4d.svg";
export { ForwardRef as ReactComponent };